//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ApiKeyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Создание нового API ключа
     * @param body (optional) 
     * @return Created
     */
    addApiKey(body: ApiKeyCreateModel | undefined): Observable<ApiKeyModel> {
        let url_ = this.baseUrl + "/api/keys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiKeyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiKeyModel>;
        }));
    }

    protected processAddApiKey(response: HttpResponseBase): Observable<ApiKeyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ApiKeyModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Получение списка API ключей компании по ID
     * @param companyId (optional) 
     * @return Success
     */
    getApiKeys(companyId: string | undefined): Observable<ApiKeyModel[]> {
        let url_ = this.baseUrl + "/api/keys?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApiKeys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApiKeys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiKeyModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiKeyModel[]>;
        }));
    }

    protected processGetApiKeys(response: HttpResponseBase): Observable<ApiKeyModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ApiKeyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Удаление API ключа по ID
     * @return No Content
     */
    deleteApiKey(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/keys/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteApiKey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает информацию об API ключе по ID
     * @return Success
     */
    getApiKey(id: string): Observable<ApiKeyModel> {
        let url_ = this.baseUrl + "/api/keys/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiKeyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiKeyModel>;
        }));
    }

    protected processGetApiKey(response: HttpResponseBase): Observable<ApiKeyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiKeyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Генерирует ссылку для авторизации
     * @param redirectUrl (optional) 
     * @return Success
     */
    generateLink(redirectUrl: string | undefined): Observable<AuthLinkResponse> {
        let url_ = this.baseUrl + "/api/auth/generateLink?";
        if (redirectUrl === null)
            throw new Error("The parameter 'redirectUrl' cannot be null.");
        else if (redirectUrl !== undefined)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthLinkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthLinkResponse>;
        }));
    }

    protected processGenerateLink(response: HttpResponseBase): Observable<AuthLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthLinkResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Обновляет рефреш токен
     * @param body (optional) 
     * @return Success
     */
    refreshToken(body: RefreshTokenRequest | undefined): Observable<JwtResponse> {
        let url_ = this.baseUrl + "/api/auth/refreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JwtResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JwtResponse>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<JwtResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JwtResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Авторизация кода авторизации который был получен после редиректа
     * @param code (optional) 
     * @return Success
     */
    authorize(code: string | undefined): Observable<JwtResponse> {
        let url_ = this.baseUrl + "/api/auth/authorize?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JwtResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JwtResponse>;
        }));
    }

    protected processAuthorize(response: HttpResponseBase): Observable<JwtResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JwtResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает информацию об авторизованном юзере
     * @return Success
     */
    me(): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/auth/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processMe(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ContactSourceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Получить все источники клиента для компании
     * @param companyId (optional) 
     * @return Created
     */
    getByCompanyId(companyId: string | undefined): Observable<ApiKeyModel> {
        let url_ = this.baseUrl + "/api/contactSources/companyId/source?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCompanyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCompanyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiKeyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiKeyModel>;
        }));
    }

    protected processGetByCompanyId(response: HttpResponseBase): Observable<ApiKeyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ApiKeyModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Получить источник клиента по ID
     * @param id (optional) 
     * @return Created
     */
    getById(id: string | undefined): Observable<ApiKeyModel> {
        let url_ = this.baseUrl + "/api/contactSources/id/source?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiKeyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiKeyModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ApiKeyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ApiKeyModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Добавить новый источник клиента
     * @param body (optional) 
     * @return Created
     */
    create(body: ContactSource | undefined): Observable<ApiKeyModel> {
        let url_ = this.baseUrl + "/api/contactSources/add/source";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiKeyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiKeyModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApiKeyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ApiKeyModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Обновить источник клиента
     * @param id (optional) 
     * @param body (optional) 
     * @return Created
     */
    update(id: string | undefined, body: ContactSource | undefined): Observable<ApiKeyModel> {
        let url_ = this.baseUrl + "/api/contactSources/update/source?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiKeyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiKeyModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApiKeyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ApiKeyModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CountryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Получение списка стран
     * @return Success
     */
    getCountries(): Observable<Country[]> {
        let url_ = this.baseUrl + "/api/countries/getCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Country[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Country[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<Country[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Country.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Получение списка штатов для страны по id
     * @param countryId (optional) 
     * @return Success
     */
    getStatesByCountryId(countryId: number | undefined): Observable<State[]> {
        let url_ = this.baseUrl + "/api/countries/getStates?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatesByCountryId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatesByCountryId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<State[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<State[]>;
        }));
    }

    protected processGetStatesByCountryId(response: HttpResponseBase): Observable<State[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(State.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Получение списка клиентов
     * @param body (optional) Модель фильтра клиентов
     * @return Success
     */
    getByFilter(body: CustomerFilterModel | undefined): Observable<CustomerModelPaginationModel> {
        let url_ = this.baseUrl + "/api/customers/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModelPaginationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModelPaginationModel>;
        }));
    }

    protected processGetByFilter(response: HttpResponseBase): Observable<CustomerModelPaginationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerModelPaginationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Создание клиента
     * @param body (optional) 
     * @return Created
     */
    create(body: CustomerCreateModel | undefined): Observable<CustomerModel> {
        let url_ = this.baseUrl + "/api/customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CustomerModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Обновление клиента
     * @param body (optional) 
     * @return Success
     */
    update(id: string, body: CustomerCreateModel | undefined): Observable<CustomerModel> {
        let url_ = this.baseUrl + "/api/customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает детали клиента
     * @return Success
     */
    getDetails(id: string): Observable<CustomerModel> {
        let url_ = this.baseUrl + "/api/customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModel>;
        }));
    }

    protected processGetDetails(response: HttpResponseBase): Observable<CustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает информацию о клиентах по глобальному поиску
     * @param body (optional) 
     * @return Success
     */
    search(body: QueryModel | undefined): Observable<CustomerModelPaginationModel> {
        let url_ = this.baseUrl + "/api/customers/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModelPaginationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModelPaginationModel>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<CustomerModelPaginationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerModelPaginationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает список логинов клиента по пагинации
     * @param id ID клиента
     * @param body (optional) Модель фильтра и пагинации
     * @return Success
     */
    getSubscriptions(id: string, body: FilterModel | undefined): Observable<SubscriptionModelPaginationModel> {
        let url_ = this.baseUrl + "/api/customers/{id}/subscriptions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionModelPaginationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionModelPaginationModel>;
        }));
    }

    protected processGetSubscriptions(response: HttpResponseBase): Observable<SubscriptionModelPaginationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionModelPaginationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возращает список заметок по клиенту
     * @param model (optional) 
     * @return Success
     */
    getNotes(id: string, model: FilterModel | undefined): Observable<CustomerNoteModelPaginationModel> {
        let url_ = this.baseUrl + "/api/customers/{id}/notes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (model === null)
            throw new Error("The parameter 'model' cannot be null.");
        else if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerNoteModelPaginationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerNoteModelPaginationModel>;
        }));
    }

    protected processGetNotes(response: HttpResponseBase): Observable<CustomerNoteModelPaginationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerNoteModelPaginationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new note
     * @param body (optional) 
     * @return Created
     */
    createNote(id: string, body: CustomerNoteCreateModel | undefined): Observable<CustomerNoteModel> {
        let url_ = this.baseUrl + "/api/customers/{id}/notes";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerNoteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerNoteModel>;
        }));
    }

    protected processCreateNote(response: HttpResponseBase): Observable<CustomerNoteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CustomerNoteModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает список платежей по клиенту
     * @param body (optional) 
     * @return Success
     */
    getPayments(id: string, body: FilterModel | undefined): Observable<PaymentModelPaginationModel> {
        let url_ = this.baseUrl + "/api/customers/{id}/payments";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentModelPaginationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentModelPaginationModel>;
        }));
    }

    protected processGetPayments(response: HttpResponseBase): Observable<PaymentModelPaginationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentModelPaginationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerNoteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Получение комментария по ID
     * @param id Идентификатор комментария
     * @return Success
     */
    getById(id: string): Observable<CustomerNote> {
        let url_ = this.baseUrl + "/api/CustomerNote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerNote>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerNote>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CustomerNote> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerNote.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Редактирование комментария
     * @param id Идентификатор комментария
     * @param body (optional) Новое описание комментария
     * @return No Content
     */
    update(id: string, body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/CustomerNote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Удаление комментария
     * @param id Идентификатор комментария
     * @return No Content
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/CustomerNote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Получение комментариев по фильтрам
     * @param companyId (optional) Идентификатор компании
     * @param userId (optional) Идентификатор пользователя
     * @param startDate (optional) Дата начала для фильтрации
     * @param endDate (optional) Дата окончания для фильтрации
     * @return Success
     */
    getByFilters(companyId: string | undefined, userId: string | undefined, startDate: Date | undefined, endDate: Date | undefined): Observable<CustomerNote[]> {
        let url_ = this.baseUrl + "/api/CustomerNote/filter?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "undefined") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "undefined") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerNote[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerNote[]>;
        }));
    }

    protected processGetByFilters(response: HttpResponseBase): Observable<CustomerNote[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerNote.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Создание статуса клиента
     * @param body (optional) 
     * @return Created
     */
    create(body: CustomerStatusCreateModel | undefined): Observable<CustomerStatusModel> {
        let url_ = this.baseUrl + "/api/customers/statuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerStatusModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerStatusModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomerStatusModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CustomerStatusModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Получение списка статусов клиентов
     * @param companyId (optional) 
     * @return Success
     */
    getAll(companyId: string | undefined): Observable<CustomerStatusModel[]> {
        let url_ = this.baseUrl + "/api/customers/statuses?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerStatusModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerStatusModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomerStatusModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerStatusModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ImportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import(body: StarberryImportContactsModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Создает новый заказ
     * @param body (optional) 
     * @return Created
     */
    create(body: OrderCreateModel | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OrderModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает заказ по ID
     * @return Success
     */
    getDetails(id: string): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/orders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processGetDetails(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Обновляет заказ
     * @param body (optional) 
     * @return Success
     */
    update(id: string, body: OrderUpdateModel | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/orders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Оплачивает заказ и добавляет оплату
     * @param body (optional) 
     * @return Created
     */
    pay(id: string, body: PaymentCreateModel | undefined): Observable<PaymentModel> {
        let url_ = this.baseUrl + "/api/orders/{id}/payments";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentModel>;
        }));
    }

    protected processPay(response: HttpResponseBase): Observable<PaymentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PaymentModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает список платежей
     * @param id Номер заказа
     * @param page (optional) Страница
     * @param perPage (optional) Количество элементов на странице
     * @return Success
     */
    getPayments(id: string, page: number | undefined, perPage: number | undefined): Observable<PaymentModelPaginationModel> {
        let url_ = this.baseUrl + "/api/orders/{id}/payments?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentModelPaginationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentModelPaginationModel>;
        }));
    }

    protected processGetPayments(response: HttpResponseBase): Observable<PaymentModelPaginationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentModelPaginationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает заказы по фильтру
     * @param body (optional) 
     * @return Success
     */
    getByFilter(body: OrderFilterModel | undefined): Observable<OrderModelPaginationModel> {
        let url_ = this.baseUrl + "/api/orders/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelPaginationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelPaginationModel>;
        }));
    }

    protected processGetByFilter(response: HttpResponseBase): Observable<OrderModelPaginationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelPaginationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает общее количество заказов по фильтру
     * @param body (optional) 
     * @return Success
     */
    getTotal(body: OrderFilterModel | undefined): Observable<TotalModel> {
        let url_ = this.baseUrl + "/api/orders/total";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalModel>;
        }));
    }

    protected processGetTotal(response: HttpResponseBase): Observable<TotalModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotalModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отправляет email с информацией о заказе
     * @return Success
     */
    sendEmail(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/orders/{id}/email";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отменяет заказ
     * @param id ID заказа
     * @param body (optional) Модель отмены заказа
     * @return Success
     */
    cancel(id: string, body: OrderCancelationModel | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/orders/{id}/cancelation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateShippingPrice(body: CalculateShippingModel | undefined): Observable<CalculateShippingResponseModel> {
        let url_ = this.baseUrl + "/api/orders/calculateShippingPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateShippingPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateShippingPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculateShippingResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculateShippingResponseModel>;
        }));
    }

    protected processCalculateShippingPrice(response: HttpResponseBase): Observable<CalculateShippingResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateShippingResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Осуществляет возврат средств по заказу
     * @param orderId (optional) ID заказа
     * @param amount (optional) Сумма возврата
     * @return Success
     */
    refundOrder(orderId: string | undefined, amount: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/payment/refund/orderId?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefundOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefundOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRefundOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Получает платежи по ID заказа
     * @param orderId (optional) ID заказа
     * @return Success
     */
    getPaymentsByOrderId(orderId: string | undefined): Observable<Payment[]> {
        let url_ = this.baseUrl + "/api/payment/payments/orderId?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentsByOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentsByOrderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Payment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Payment[]>;
        }));
    }

    protected processGetPaymentsByOrderId(response: HttpResponseBase): Observable<Payment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Payment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Получает платежи по фильтрам
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param minAmount (optional) 
     * @param maxAmount (optional) 
     * @param status (optional) 
     * @return Success
     */
    getPaymentsByFilters(startDate: Date | undefined, endDate: Date | undefined, minAmount: number | undefined, maxAmount: number | undefined, status: PaymentStatus | undefined): Observable<Payment[]> {
        let url_ = this.baseUrl + "/api/payment/payments?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "undefined") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "undefined") + "&";
        if (minAmount === null)
            throw new Error("The parameter 'minAmount' cannot be null.");
        else if (minAmount !== undefined)
            url_ += "minAmount=" + encodeURIComponent("" + minAmount) + "&";
        if (maxAmount === null)
            throw new Error("The parameter 'maxAmount' cannot be null.");
        else if (maxAmount !== undefined)
            url_ += "maxAmount=" + encodeURIComponent("" + maxAmount) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentsByFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentsByFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Payment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Payment[]>;
        }));
    }

    protected processGetPaymentsByFilters(response: HttpResponseBase): Observable<Payment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Payment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Возвращает список товаров в пагинации
     * @param filter (optional) 
     * @return Success
     */
    getByFilter(filter: ProductFilterModel | undefined): Observable<ProductModelPaginationModel> {
        let url_ = this.baseUrl + "/api/products?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModelPaginationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModelPaginationModel>;
        }));
    }

    protected processGetByFilter(response: HttpResponseBase): Observable<ProductModelPaginationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductModelPaginationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Добавляет новый товар
     * @param body (optional) Модель создания товара
     * @return Created
     */
    create(body: ProductCreateModel | undefined): Observable<ProductModel> {
        let url_ = this.baseUrl + "/api/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ProductModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Обновляет товар в системе
     * @param id ID товара
     * @param body (optional) модель обновления товара
     * @return Success
     */
    update(id: string, body: ProductCreateModel | undefined): Observable<ProductModel> {
        let url_ = this.baseUrl + "/api/products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProductModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает детали товара
     * @param id ID товара
     * @return Success
     */
    getDetails(id: string): Observable<ProductModel> {
        let url_ = this.baseUrl + "/api/products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel>;
        }));
    }

    protected processGetDetails(response: HttpResponseBase): Observable<ProductModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает параметры товара
     * @param id ID товара
     * @return Success
     */
    getProperties(id: string): Observable<ProductPropertyModel[]> {
        let url_ = this.baseUrl + "/api/products/{id}/properties";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductPropertyModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductPropertyModel[]>;
        }));
    }

    protected processGetProperties(response: HttpResponseBase): Observable<ProductPropertyModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductPropertyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Добавляет параметр товару
     * @param id ID товара
     * @param body (optional) Модель параметра
     * @return Created
     */
    addProperty(id: string, body: ProductPropertyCreateModel | undefined): Observable<ProductPropertyModel> {
        let url_ = this.baseUrl + "/api/products/{id}/properties";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductPropertyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductPropertyModel>;
        }));
    }

    protected processAddProperty(response: HttpResponseBase): Observable<ProductPropertyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ProductPropertyModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Обновляет параметр товара
     * @param id ID товара
     * @param propertyId ID параметра
     * @param body (optional) Модель обновления параметра
     * @return Success
     */
    updateProperty(id: string, propertyId: string, body: ProductPropertyCreateModel | undefined): Observable<ProductPropertyModel> {
        let url_ = this.baseUrl + "/api/products/{id}/properties/{propertyId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductPropertyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductPropertyModel>;
        }));
    }

    protected processUpdateProperty(response: HttpResponseBase): Observable<ProductPropertyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductPropertyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Удаляет параметр товара
     * @return No Content
     */
    deleteProperty(id: string, propertyId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/products/{id}/properties/{propertyId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProperty(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SalesStatisticsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Получить статистику доходов и расходов за указанный период.
     * @param companyId (optional) ID компании
     * @param period (optional) 
     * @return Success
     */
    getStatistics(companyId: string | undefined, period: string | undefined): Observable<SalesStatisticsDto> {
        let url_ = this.baseUrl + "/api/SalesStatistics?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (period === null)
            throw new Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesStatisticsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesStatisticsDto>;
        }));
    }

    protected processGetStatistics(response: HttpResponseBase): Observable<SalesStatisticsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesStatisticsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StatisticsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getClientsCount(companyId: string | undefined): Observable<ClientsCountResponse> {
        let url_ = this.baseUrl + "/api/StatisticsController/clients-count?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientsCountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientsCountResponse>;
        }));
    }

    protected processGetClientsCount(response: HttpResponseBase): Observable<ClientsCountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientsCountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отримання кількості замовлень за тиждень та відсоток зміни
     * @param companyId (optional) 
     * @return Success
     */
    getOrdersCount(companyId: string | undefined): Observable<OrdersCountResponse> {
        let url_ = this.baseUrl + "/api/StatisticsController/orders-count?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrdersCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrdersCountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrdersCountResponse>;
        }));
    }

    protected processGetOrdersCount(response: HttpResponseBase): Observable<OrdersCountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrdersCountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отримання доходу за тиждень та відсоток зміни
     * @param companyId (optional) 
     * @return Success
     */
    getRevenue(companyId: string | undefined): Observable<RevenueResponse> {
        let url_ = this.baseUrl + "/api/StatisticsController/revenue?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRevenue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevenue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevenueResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevenueResponse>;
        }));
    }

    protected processGetRevenue(response: HttpResponseBase): Observable<RevenueResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevenueResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StatusHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Получает историю статусов клиента по его идентификатору.
     * @param customerId (optional) 
     * @return Success
     */
    getStatusHistoryForCustomer(customerId: string | undefined): Observable<CustomerStatus[]> {
        let url_ = this.baseUrl + "/api/status-history/client/clientId?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusHistoryForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusHistoryForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerStatus[]>;
        }));
    }

    protected processGetStatusHistoryForCustomer(response: HttpResponseBase): Observable<CustomerStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            let resultData502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result502 = ErrorTemplate.fromJS(resultData502);
            return throwException("Server Error", status, _responseText, _headers, result502);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Получает изменения статусов по заданному периоду и статусу.
     * @param statusId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getCustomersByStatusInPeriod(statusId: string | undefined, startDate: Date | undefined, endDate: Date | undefined): Observable<CustomerStatus[]> {
        let url_ = this.baseUrl + "/api/status-history/period?";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "undefined") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "undefined") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomersByStatusInPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomersByStatusInPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerStatus[]>;
        }));
    }

    protected processGetCustomersByStatusInPeriod(response: HttpResponseBase): Observable<CustomerStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            let resultData502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result502 = ErrorTemplate.fromJS(resultData502);
            return throwException("Server Error", status, _responseText, _headers, result502);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Возвращает подписки по фильтру
     * @param body (optional) Фильтр
     * @return Success
     */
    getSubscriptions(body: SubscriptionFilter | undefined): Observable<SubscriptionModelPaginationModel> {
        let url_ = this.baseUrl + "/api/subscriptions/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionModelPaginationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionModelPaginationModel>;
        }));
    }

    protected processGetSubscriptions(response: HttpResponseBase): Observable<SubscriptionModelPaginationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionModelPaginationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Обновляет информацию о подписке
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateSubscription(id: string | undefined, body: SubscriptionUpdateModel | undefined): Observable<SubscriptionModel> {
        let url_ = this.baseUrl + "/api/subscriptions/update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionModel>;
        }));
    }

    protected processUpdateSubscription(response: HttpResponseBase): Observable<SubscriptionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            let resultData502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result502 = ErrorTemplate.fromJS(resultData502);
            return throwException("Server Error", status, _responseText, _headers, result502);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Обновляет свойство подписки
     * @param id (optional) ID подписки
     * @param propertyId ID свойства подписки
     * @param body (optional) Модель со значением свойства
     * @return Success
     */
    updateSubscriptionProperty(id: string | undefined, propertyId: string, body: PropertyUpdateModel | undefined): Observable<SubscriptionModel> {
        let url_ = this.baseUrl + "/api/subscriptions/properties/{propertyId}?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubscriptionProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscriptionProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionModel>;
        }));
    }

    protected processUpdateSubscriptionProperty(response: HttpResponseBase): Observable<SubscriptionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            let resultData502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result502 = ErrorTemplate.fromJS(resultData502);
            return throwException("Server Error", status, _responseText, _headers, result502);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Удаляет свойство подписки
     * @param id (optional) 
     * @return Success
     */
    deleteSubscriptionProperty(id: string | undefined, propertyId: string): Observable<SubscriptionModel> {
        let url_ = this.baseUrl + "/api/subscriptions/properties/{propertyId}?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubscriptionProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubscriptionProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionModel>;
        }));
    }

    protected processDeleteSubscriptionProperty(response: HttpResponseBase): Observable<SubscriptionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            let resultData502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result502 = ErrorTemplate.fromJS(resultData502);
            return throwException("Server Error", status, _responseText, _headers, result502);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает подписку по ID
     * @return Success
     */
    getSubscription(id: string): Observable<SubscriptionModel> {
        let url_ = this.baseUrl + "/api/subscriptions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionModel>;
        }));
    }

    protected processGetSubscription(response: HttpResponseBase): Observable<SubscriptionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Синхронизирует подписку с внешним сервисом
     * @return Success
     */
    syncSubscription(id: string): Observable<SubscriptionModel> {
        let url_ = this.baseUrl + "/api/subscriptions/{id}/sync";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionModel>;
        }));
    }

    protected processSyncSubscription(response: HttpResponseBase): Observable<SubscriptionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Продлевает подписку клиента
     * @param id ID подписки
     * @param body (optional) Модель продления подписки
     * @return No Content
     */
    prolongSubscription(id: string, body: SubscriptionPaymentCreateModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/subscriptions/{id}/prolong";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProlongSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProlongSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProlongSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorTemplate.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTemplate.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Возвращает список пользователей
     * @param companyId (optional) 
     * @return Success
     */
    getUsers(companyId: string | undefined): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/users?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Возвращает пользователя по ID
     * @return Success
     */
    get(id: string): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorTemplate.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorTemplate.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorTemplate.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AdditionalInfo implements IAdditionalInfo {
    additionalFirstname?: string | undefined;
    additionalLastname?: string | undefined;
    additionalPhone?: string | undefined;
    additionalEmail?: string | undefined;
    additionalAddress?: string | undefined;

    constructor(data?: IAdditionalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalFirstname = _data["additionalFirstname"];
            this.additionalLastname = _data["additionalLastname"];
            this.additionalPhone = _data["additionalPhone"];
            this.additionalEmail = _data["additionalEmail"];
            this.additionalAddress = _data["additionalAddress"];
        }
    }

    static fromJS(data: any): AdditionalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalFirstname"] = this.additionalFirstname;
        data["additionalLastname"] = this.additionalLastname;
        data["additionalPhone"] = this.additionalPhone;
        data["additionalEmail"] = this.additionalEmail;
        data["additionalAddress"] = this.additionalAddress;
        return data;
    }

    clone(): AdditionalInfo {
        const json = this.toJSON();
        let result = new AdditionalInfo();
        result.init(json);
        return result;
    }
}

export interface IAdditionalInfo {
    additionalFirstname?: string | undefined;
    additionalLastname?: string | undefined;
    additionalPhone?: string | undefined;
    additionalEmail?: string | undefined;
    additionalAddress?: string | undefined;
}

/** Модель адреса */
export class AddressModel implements IAddressModel {
    /** Имя */
    firstname?: string | undefined;
    /** Фамилия */
    lastname?: string | undefined;
    /** Имейл */
    email?: string | undefined;
    /** Телефон */
    phone?: string | undefined;
    /** Название адреса */
    name?: string | undefined;
    /** Улица, дом */
    street?: string | undefined;
    /** Город */
    city?: string | undefined;
    /** Страна */
    country?: string | undefined;
    /** Штат/Регион/Область */
    state?: string | undefined;
    /** Почтовый индекс */
    postalCode?: string | undefined;
    /** Комментарий к адресу */
    comment?: string | undefined;

    constructor(data?: IAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.name = _data["name"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): AddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["name"] = this.name;
        data["street"] = this.street;
        data["city"] = this.city;
        data["country"] = this.country;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["comment"] = this.comment;
        return data;
    }

    clone(): AddressModel {
        const json = this.toJSON();
        let result = new AddressModel();
        result.init(json);
        return result;
    }
}

/** Модель адреса */
export interface IAddressModel {
    /** Имя */
    firstname?: string | undefined;
    /** Фамилия */
    lastname?: string | undefined;
    /** Имейл */
    email?: string | undefined;
    /** Телефон */
    phone?: string | undefined;
    /** Название адреса */
    name?: string | undefined;
    /** Улица, дом */
    street?: string | undefined;
    /** Город */
    city?: string | undefined;
    /** Страна */
    country?: string | undefined;
    /** Штат/Регион/Область */
    state?: string | undefined;
    /** Почтовый индекс */
    postalCode?: string | undefined;
    /** Комментарий к адресу */
    comment?: string | undefined;
}

/** Модель создания и редактирования API ключа */
export class ApiKeyCreateModel implements IApiKeyCreateModel {
    /** Название ключа */
    name?: string | undefined;
    /** ID компании, к которой привязан ключ */
    companyId?: string | undefined;

    constructor(data?: IApiKeyCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): ApiKeyCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApiKeyCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        return data;
    }

    clone(): ApiKeyCreateModel {
        const json = this.toJSON();
        let result = new ApiKeyCreateModel();
        result.init(json);
        return result;
    }
}

/** Модель создания и редактирования API ключа */
export interface IApiKeyCreateModel {
    /** Название ключа */
    name?: string | undefined;
    /** ID компании, к которой привязан ключ */
    companyId?: string | undefined;
}

/** Модель API ключа */
export class ApiKeyModel implements IApiKeyModel {
    /** ID компании, к которой привязан ключ */
    companyId?: string;
    /** Ключ доступа */
    key?: string | undefined;
    /** Название ключа */
    name?: string | undefined;
    /** Дата и время последнего использования ключа */
    lastUsedAt?: Date | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IApiKeyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.key = _data["key"];
            this.name = _data["name"];
            this.lastUsedAt = _data["lastUsedAt"] ? new Date(_data["lastUsedAt"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): ApiKeyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApiKeyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["key"] = this.key;
        data["name"] = this.name;
        data["lastUsedAt"] = this.lastUsedAt ? this.lastUsedAt.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): ApiKeyModel {
        const json = this.toJSON();
        let result = new ApiKeyModel();
        result.init(json);
        return result;
    }
}

/** Модель API ключа */
export interface IApiKeyModel {
    /** ID компании, к которой привязан ключ */
    companyId?: string;
    /** Ключ доступа */
    key?: string | undefined;
    /** Название ключа */
    name?: string | undefined;
    /** Дата и время последнего использования ключа */
    lastUsedAt?: Date | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель запроса на авторизацию */
export class AuthLinkResponse implements IAuthLinkResponse {
    /** URL для авторизации */
    url?: string | undefined;

    constructor(data?: IAuthLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): AuthLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }

    clone(): AuthLinkResponse {
        const json = this.toJSON();
        let result = new AuthLinkResponse();
        result.init(json);
        return result;
    }
}

/** Модель запроса на авторизацию */
export interface IAuthLinkResponse {
    /** URL для авторизации */
    url?: string | undefined;
}

/** Модель для расчета стоимости доставки */
export class CalculateShippingModel implements ICalculateShippingModel {
    /** ID компании, с которой будет производится расчет стоимости */
    companyId?: string;
    /** Товары, которые нужно доставить */
    products?: OrderProductCreateModel[] | undefined;
    /** Адрес доставки (Куда будем доставлять) */
    shippingAddress?: AddressModel | undefined;

    constructor(data?: ICalculateShippingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(OrderProductCreateModel.fromJS(item));
            }
            this.shippingAddress = _data["shippingAddress"] ? AddressModel.fromJS(_data["shippingAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CalculateShippingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateShippingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        return data;
    }

    clone(): CalculateShippingModel {
        const json = this.toJSON();
        let result = new CalculateShippingModel();
        result.init(json);
        return result;
    }
}

/** Модель для расчета стоимости доставки */
export interface ICalculateShippingModel {
    /** ID компании, с которой будет производится расчет стоимости */
    companyId?: string;
    /** Товары, которые нужно доставить */
    products?: OrderProductCreateModel[] | undefined;
    /** Адрес доставки (Куда будем доставлять) */
    shippingAddress?: AddressModel | undefined;
}

/** Модель ответа на расчет стоимости доставки */
export class CalculateShippingResponseModel implements ICalculateShippingResponseModel {
    /** Сумма доставки */
    total?: number;

    constructor(data?: ICalculateShippingResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): CalculateShippingResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateShippingResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        return data;
    }

    clone(): CalculateShippingResponseModel {
        const json = this.toJSON();
        let result = new CalculateShippingResponseModel();
        result.init(json);
        return result;
    }
}

/** Модель ответа на расчет стоимости доставки */
export interface ICalculateShippingResponseModel {
    /** Сумма доставки */
    total?: number;
}

export class ClientsCountResponse implements IClientsCountResponse {
    currentCount?: number;
    previousCount?: number;
    percentageChange?: number | undefined;

    constructor(data?: IClientsCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentCount = _data["currentCount"];
            this.previousCount = _data["previousCount"];
            this.percentageChange = _data["percentageChange"];
        }
    }

    static fromJS(data: any): ClientsCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientsCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentCount"] = this.currentCount;
        data["previousCount"] = this.previousCount;
        data["percentageChange"] = this.percentageChange;
        return data;
    }

    clone(): ClientsCountResponse {
        const json = this.toJSON();
        let result = new ClientsCountResponse();
        result.init(json);
        return result;
    }
}

export interface IClientsCountResponse {
    currentCount?: number;
    previousCount?: number;
    percentageChange?: number | undefined;
}

/** Источник клиента */
export class ContactSource implements IContactSource {
    /** Уникальный идентификатор источника */
    id?: string;
    /** Идентификатор компании, к которой относится источник */
    companyId?: string;
    /** Название источника клиента */
    name?: string | undefined;
    /** UTM-метка source */
    source?: string | undefined;
    /** UTM-метка medium */
    medium?: string | undefined;
    /** UTM-метка campaign */
    campaign?: string | undefined;
    /** UTM-метка term */
    term?: string | undefined;
    /** UTM-метка content */
    content?: string | undefined;

    constructor(data?: IContactSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.source = _data["source"];
            this.medium = _data["medium"];
            this.campaign = _data["campaign"];
            this.term = _data["term"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): ContactSource {
        data = typeof data === 'object' ? data : {};
        let result = new ContactSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["source"] = this.source;
        data["medium"] = this.medium;
        data["campaign"] = this.campaign;
        data["term"] = this.term;
        data["content"] = this.content;
        return data;
    }

    clone(): ContactSource {
        const json = this.toJSON();
        let result = new ContactSource();
        result.init(json);
        return result;
    }
}

/** Источник клиента */
export interface IContactSource {
    /** Уникальный идентификатор источника */
    id?: string;
    /** Идентификатор компании, к которой относится источник */
    companyId?: string;
    /** Название источника клиента */
    name?: string | undefined;
    /** UTM-метка source */
    source?: string | undefined;
    /** UTM-метка medium */
    medium?: string | undefined;
    /** UTM-метка campaign */
    campaign?: string | undefined;
    /** UTM-метка term */
    term?: string | undefined;
    /** UTM-метка content */
    content?: string | undefined;
}

export class Country implements ICountry {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }

    clone(): Country {
        const json = this.toJSON();
        let result = new Country();
        result.init(json);
        return result;
    }
}

export interface ICountry {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
}

/** Модель кастомной услуги в заказе */
export class CustomFeeModel implements ICustomFeeModel {
    /** ID услуги (Строка. Для кастомной логики. Например - аналитики заказов) */
    id?: string | undefined;
    /** Название услуги */
    name?: string | undefined;
    /** Сумма услуги */
    amount?: number;
    /** Комментарий к услуге */
    comment?: string | undefined;

    constructor(data?: ICustomFeeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CustomFeeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFeeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["amount"] = this.amount;
        data["comment"] = this.comment;
        return data;
    }

    clone(): CustomFeeModel {
        const json = this.toJSON();
        let result = new CustomFeeModel();
        result.init(json);
        return result;
    }
}

/** Модель кастомной услуги в заказе */
export interface ICustomFeeModel {
    /** ID услуги (Строка. Для кастомной логики. Например - аналитики заказов) */
    id?: string | undefined;
    /** Название услуги */
    name?: string | undefined;
    /** Сумма услуги */
    amount?: number;
    /** Комментарий к услуге */
    comment?: string | undefined;
}

/** Клиент либо лид */
export class Customer implements ICustomer {
    /** ID компании, к которой привязан клиент */
    companyId?: string;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Метаданные клиента (UTM метки) которые привели его в первый раз */
    utmMetadata?: UtmModel | undefined;
    /** Список заказов */
    orders?: Order[] | undefined;
    /** Пароль клиента для доступа в систему личного кабинета на сайте. Хранится в зашифрованном виде.
По умолчанию пароль не установлен. Но клиент не сможет авторизоваться в системе, пока не установит пароль при первом входе. */
    password?: string | undefined;
    /** Взаимодействие с клиентом. Взаимодействие может быть с сайта или рекламной кампании либо пользователем */
    interactions?: CustomerInteraction[] | undefined;
    /** Заметки о клиенте */
    notes?: CustomerNote[] | undefined;
    /** Статус клиента */
    statusId?: string;
    /** Статус клиента */
    status?: CustomerStatus | undefined;
    /** Менеджер */
    userId?: string | undefined;
    /** Менеджер */
    user?: User | undefined;
    /** Адрес */
    address?: AddressModel | undefined;
    /** Дополнительное Имя клиента */
    additionalInfo?: AdditionalInfo[] | undefined;
    /** Параметры клиента */
    properties?: CustomerProperty[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.utmMetadata = _data["utmMetadata"] ? UtmModel.fromJS(_data["utmMetadata"]) : <any>undefined;
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(Order.fromJS(item));
            }
            this.password = _data["password"];
            if (Array.isArray(_data["interactions"])) {
                this.interactions = [] as any;
                for (let item of _data["interactions"])
                    this.interactions.push(CustomerInteraction.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(CustomerNote.fromJS(item));
            }
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? CustomerStatus.fromJS(_data["status"]) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["additionalInfo"])) {
                this.additionalInfo = [] as any;
                for (let item of _data["additionalInfo"])
                    this.additionalInfo.push(AdditionalInfo.fromJS(item));
            }
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties.push(CustomerProperty.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["utmMetadata"] = this.utmMetadata ? this.utmMetadata.toJSON() : <any>undefined;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["password"] = this.password;
        if (Array.isArray(this.interactions)) {
            data["interactions"] = [];
            for (let item of this.interactions)
                data["interactions"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.additionalInfo)) {
            data["additionalInfo"] = [];
            for (let item of this.additionalInfo)
                data["additionalInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): Customer {
        const json = this.toJSON();
        let result = new Customer();
        result.init(json);
        return result;
    }
}

/** Клиент либо лид */
export interface ICustomer {
    /** ID компании, к которой привязан клиент */
    companyId?: string;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Метаданные клиента (UTM метки) которые привели его в первый раз */
    utmMetadata?: UtmModel | undefined;
    /** Список заказов */
    orders?: Order[] | undefined;
    /** Пароль клиента для доступа в систему личного кабинета на сайте. Хранится в зашифрованном виде.
По умолчанию пароль не установлен. Но клиент не сможет авторизоваться в системе, пока не установит пароль при первом входе. */
    password?: string | undefined;
    /** Взаимодействие с клиентом. Взаимодействие может быть с сайта или рекламной кампании либо пользователем */
    interactions?: CustomerInteraction[] | undefined;
    /** Заметки о клиенте */
    notes?: CustomerNote[] | undefined;
    /** Статус клиента */
    statusId?: string;
    /** Статус клиента */
    status?: CustomerStatus | undefined;
    /** Менеджер */
    userId?: string | undefined;
    /** Менеджер */
    user?: User | undefined;
    /** Адрес */
    address?: AddressModel | undefined;
    /** Дополнительное Имя клиента */
    additionalInfo?: AdditionalInfo[] | undefined;
    /** Параметры клиента */
    properties?: CustomerProperty[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель создания клиента */
export class CustomerCreateModel implements ICustomerCreateModel {
    /** ID компании, к которой привязан клиент */
    companyId?: string | undefined;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Метаданные клиента (UTM метки) которые привели его в первый раз */
    utmMetadata?: UtmModel | undefined;
    /** Новый статус клиента */
    status?: CustomerStatusModel | undefined;
    /** ID пользователя, который добавил клиента */
    userId?: string | undefined;
    /** Адрес клиента */
    address?: AddressModel | undefined;
    additionalInfo?: AdditionalInfo[] | undefined;

    constructor(data?: ICustomerCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.utmMetadata = _data["utmMetadata"] ? UtmModel.fromJS(_data["utmMetadata"]) : <any>undefined;
            this.status = _data["status"] ? CustomerStatusModel.fromJS(_data["status"]) : <any>undefined;
            this.userId = _data["userId"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["additionalInfo"])) {
                this.additionalInfo = [] as any;
                for (let item of _data["additionalInfo"])
                    this.additionalInfo.push(AdditionalInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["utmMetadata"] = this.utmMetadata ? this.utmMetadata.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.additionalInfo)) {
            data["additionalInfo"] = [];
            for (let item of this.additionalInfo)
                data["additionalInfo"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerCreateModel {
        const json = this.toJSON();
        let result = new CustomerCreateModel();
        result.init(json);
        return result;
    }
}

/** Модель создания клиента */
export interface ICustomerCreateModel {
    /** ID компании, к которой привязан клиент */
    companyId?: string | undefined;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Метаданные клиента (UTM метки) которые привели его в первый раз */
    utmMetadata?: UtmModel | undefined;
    /** Новый статус клиента */
    status?: CustomerStatusModel | undefined;
    /** ID пользователя, который добавил клиента */
    userId?: string | undefined;
    /** Адрес клиента */
    address?: AddressModel | undefined;
    additionalInfo?: AdditionalInfo[] | undefined;
}

/** Модель фильтра клиентов */
export class CustomerFilterModel implements ICustomerFilterModel {
    /** Id клиента */
    id?: string | undefined;
    /** Имя клиента. Включает в себя имя и фамилию */
    name?: string | undefined;
    /** Имейл клиента */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Статусы клиентов (Guid id статусов) */
    statuses?: string[] | undefined;
    /** Компании клиентов (Guid id компаний) */
    companies?: string[] | undefined;
    /** Пользователи которые добавили клиентов (Guid id пользователей) */
    users?: string[] | undefined;
    /** Filter by login */
    login?: string | undefined;
    /** Текущая страница */
    page?: number;
    /** Количество элементов на странице */
    perPage?: number;
    /** Сортировка */
    sortOrder?: SortOrder;
    /** Поле по которому сортируем */
    sortBy?: string | undefined;

    constructor(data?: ICustomerFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses.push(item);
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies.push(item);
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users.push(item);
            }
            this.login = _data["login"];
            this.page = _data["page"];
            this.perPage = _data["perPage"];
            this.sortOrder = _data["sortOrder"];
            this.sortBy = _data["sortBy"];
        }
    }

    static fromJS(data: any): CustomerFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        data["login"] = this.login;
        data["page"] = this.page;
        data["perPage"] = this.perPage;
        data["sortOrder"] = this.sortOrder;
        data["sortBy"] = this.sortBy;
        return data;
    }

    clone(): CustomerFilterModel {
        const json = this.toJSON();
        let result = new CustomerFilterModel();
        result.init(json);
        return result;
    }
}

/** Модель фильтра клиентов */
export interface ICustomerFilterModel {
    /** Id клиента */
    id?: string | undefined;
    /** Имя клиента. Включает в себя имя и фамилию */
    name?: string | undefined;
    /** Имейл клиента */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Статусы клиентов (Guid id статусов) */
    statuses?: string[] | undefined;
    /** Компании клиентов (Guid id компаний) */
    companies?: string[] | undefined;
    /** Пользователи которые добавили клиентов (Guid id пользователей) */
    users?: string[] | undefined;
    /** Filter by login */
    login?: string | undefined;
    /** Текущая страница */
    page?: number;
    /** Количество элементов на странице */
    perPage?: number;
    /** Сортировка */
    sortOrder?: SortOrder;
    /** Поле по которому сортируем */
    sortBy?: string | undefined;
}

/** Взаимодействие клиента. К примеру - рекламная интеракция. */
export class CustomerInteraction implements ICustomerInteraction {
    /** Id  клиента */
    customerId?: string;
    /** Клиент */
    customer?: Customer | undefined;
    /** Тип взаимодействия */
    type?: string | undefined;
    /** Данные взаимодействия */
    data?: string | undefined;
    /** Данные UTM (если есть) */
    utmData?: UtmModel | undefined;
    /** Id пользователя */
    userId?: string | undefined;
    /** Пользователь */
    user?: User | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: ICustomerInteraction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.type = _data["type"];
            this.data = _data["data"];
            this.utmData = _data["utmData"] ? UtmModel.fromJS(_data["utmData"]) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): CustomerInteraction {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInteraction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["data"] = this.data;
        data["utmData"] = this.utmData ? this.utmData.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): CustomerInteraction {
        const json = this.toJSON();
        let result = new CustomerInteraction();
        result.init(json);
        return result;
    }
}

/** Взаимодействие клиента. К примеру - рекламная интеракция. */
export interface ICustomerInteraction {
    /** Id  клиента */
    customerId?: string;
    /** Клиент */
    customer?: Customer | undefined;
    /** Тип взаимодействия */
    type?: string | undefined;
    /** Данные взаимодействия */
    data?: string | undefined;
    /** Данные UTM (если есть) */
    utmData?: UtmModel | undefined;
    /** Id пользователя */
    userId?: string | undefined;
    /** Пользователь */
    user?: User | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель клиента */
export class CustomerModel implements ICustomerModel {
    companyId?: string;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Метаданные клиента (UTM метки) которые привели его в первый раз */
    utmMetadata?: UtmModel | undefined;
    /** Статус клиента */
    statusId?: string;
    /** Статус клиента */
    status?: CustomerStatusModel | undefined;
    /** Менеджер */
    user?: UserModel | undefined;
    /** Адрес клиента */
    address?: AddressModel | undefined;
    additionalInfo?: AdditionalInfo[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: ICustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.utmMetadata = _data["utmMetadata"] ? UtmModel.fromJS(_data["utmMetadata"]) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? CustomerStatusModel.fromJS(_data["status"]) : <any>undefined;
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["additionalInfo"])) {
                this.additionalInfo = [] as any;
                for (let item of _data["additionalInfo"])
                    this.additionalInfo.push(AdditionalInfo.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): CustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["utmMetadata"] = this.utmMetadata ? this.utmMetadata.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.additionalInfo)) {
            data["additionalInfo"] = [];
            for (let item of this.additionalInfo)
                data["additionalInfo"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): CustomerModel {
        const json = this.toJSON();
        let result = new CustomerModel();
        result.init(json);
        return result;
    }
}

/** Модель клиента */
export interface ICustomerModel {
    companyId?: string;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Метаданные клиента (UTM метки) которые привели его в первый раз */
    utmMetadata?: UtmModel | undefined;
    /** Статус клиента */
    statusId?: string;
    /** Статус клиента */
    status?: CustomerStatusModel | undefined;
    /** Менеджер */
    user?: UserModel | undefined;
    /** Адрес клиента */
    address?: AddressModel | undefined;
    additionalInfo?: AdditionalInfo[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель пагинации которая возвращается на фронтенд */
export class CustomerModelPaginationModel implements ICustomerModelPaginationModel {
    /** Список элементов */
    items?: CustomerModel[] | undefined;
    /** Количество элементов на странице */
    perPage?: number;
    /** Номер страницы */
    page?: number;
    /** Общее количество элементов с учётом всех фильтров которые были применены */
    total?: number;
    /** Последняя страница */
    lastPage?: number;

    constructor(data?: ICustomerModelPaginationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerModel.fromJS(item));
            }
            this.perPage = _data["perPage"];
            this.page = _data["page"];
            this.total = _data["total"];
            this.lastPage = _data["lastPage"];
        }
    }

    static fromJS(data: any): CustomerModelPaginationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModelPaginationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["perPage"] = this.perPage;
        data["page"] = this.page;
        data["total"] = this.total;
        data["lastPage"] = this.lastPage;
        return data;
    }

    clone(): CustomerModelPaginationModel {
        const json = this.toJSON();
        let result = new CustomerModelPaginationModel();
        result.init(json);
        return result;
    }
}

/** Модель пагинации которая возвращается на фронтенд */
export interface ICustomerModelPaginationModel {
    /** Список элементов */
    items?: CustomerModel[] | undefined;
    /** Количество элементов на странице */
    perPage?: number;
    /** Номер страницы */
    page?: number;
    /** Общее количество элементов с учётом всех фильтров которые были применены */
    total?: number;
    /** Последняя страница */
    lastPage?: number;
}

/** Заметка о клиенте */
export class CustomerNote implements ICustomerNote {
    /** ID пользователя, создавшего заметку */
    userId?: string;
    /** Пользователь, создавший заметку */
    user?: User | undefined;
    description?: string | undefined;
    /** Текст заметки */
    text?: string | undefined;
    /** ID клиента, к которому привязана заметка */
    customerId?: string;
    /** Клиент, к которому привязана заметка */
    customer?: Customer | undefined;
    isDeleted?: boolean;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: ICustomerNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.description = _data["description"];
            this.text = _data["text"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): CustomerNote {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["text"] = this.text;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): CustomerNote {
        const json = this.toJSON();
        let result = new CustomerNote();
        result.init(json);
        return result;
    }
}

/** Заметка о клиенте */
export interface ICustomerNote {
    /** ID пользователя, создавшего заметку */
    userId?: string;
    /** Пользователь, создавший заметку */
    user?: User | undefined;
    description?: string | undefined;
    /** Текст заметки */
    text?: string | undefined;
    /** ID клиента, к которому привязана заметка */
    customerId?: string;
    /** Клиент, к которому привязана заметка */
    customer?: Customer | undefined;
    isDeleted?: boolean;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель заметки по клиенту */
export class CustomerNoteCreateModel implements ICustomerNoteCreateModel {
    /** Текст заметки */
    text?: string | undefined;

    constructor(data?: ICustomerNoteCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): CustomerNoteCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerNoteCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }

    clone(): CustomerNoteCreateModel {
        const json = this.toJSON();
        let result = new CustomerNoteCreateModel();
        result.init(json);
        return result;
    }
}

/** Модель заметки по клиенту */
export interface ICustomerNoteCreateModel {
    /** Текст заметки */
    text?: string | undefined;
}

export class CustomerNoteModel implements ICustomerNoteModel {
    userId?: string;
    /** Модель пользователя */
    user?: UserModel | undefined;
    /** TODO */
    description?: string | undefined;
    /** Текст заметки */
    text?: string | undefined;
    /** Удалена ли заметка */
    isDeleted?: boolean;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: ICustomerNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.description = _data["description"];
            this.text = _data["text"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): CustomerNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["text"] = this.text;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): CustomerNoteModel {
        const json = this.toJSON();
        let result = new CustomerNoteModel();
        result.init(json);
        return result;
    }
}

export interface ICustomerNoteModel {
    userId?: string;
    /** Модель пользователя */
    user?: UserModel | undefined;
    /** TODO */
    description?: string | undefined;
    /** Текст заметки */
    text?: string | undefined;
    /** Удалена ли заметка */
    isDeleted?: boolean;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель пагинации которая возвращается на фронтенд */
export class CustomerNoteModelPaginationModel implements ICustomerNoteModelPaginationModel {
    /** Список элементов */
    items?: CustomerNoteModel[] | undefined;
    /** Количество элементов на странице */
    perPage?: number;
    /** Номер страницы */
    page?: number;
    /** Общее количество элементов с учётом всех фильтров которые были применены */
    total?: number;
    /** Последняя страница */
    lastPage?: number;

    constructor(data?: ICustomerNoteModelPaginationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerNoteModel.fromJS(item));
            }
            this.perPage = _data["perPage"];
            this.page = _data["page"];
            this.total = _data["total"];
            this.lastPage = _data["lastPage"];
        }
    }

    static fromJS(data: any): CustomerNoteModelPaginationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerNoteModelPaginationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["perPage"] = this.perPage;
        data["page"] = this.page;
        data["total"] = this.total;
        data["lastPage"] = this.lastPage;
        return data;
    }

    clone(): CustomerNoteModelPaginationModel {
        const json = this.toJSON();
        let result = new CustomerNoteModelPaginationModel();
        result.init(json);
        return result;
    }
}

/** Модель пагинации которая возвращается на фронтенд */
export interface ICustomerNoteModelPaginationModel {
    /** Список элементов */
    items?: CustomerNoteModel[] | undefined;
    /** Количество элементов на странице */
    perPage?: number;
    /** Номер страницы */
    page?: number;
    /** Общее количество элементов с учётом всех фильтров которые были применены */
    total?: number;
    /** Последняя страница */
    lastPage?: number;
}

/** Параметра клиента */
export class CustomerProperty implements ICustomerProperty {
    /** Название параметра (код) */
    name?: string | undefined;
    /** Значение параметра */
    value?: string | undefined;
    /** ID клиента */
    customerId?: string;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: ICustomerProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.customerId = _data["customerId"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): CustomerProperty {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["customerId"] = this.customerId;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): CustomerProperty {
        const json = this.toJSON();
        let result = new CustomerProperty();
        result.init(json);
        return result;
    }
}

/** Параметра клиента */
export interface ICustomerProperty {
    /** Название параметра (код) */
    name?: string | undefined;
    /** Значение параметра */
    value?: string | undefined;
    /** ID клиента */
    customerId?: string;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Статус клиента */
export class CustomerStatus implements ICustomerStatus {
    /** Название статуса */
    name?: string | undefined;
    /** ID компании, к которой привязан статус */
    companyId?: string;
    /** Включен ли статус */
    isEnabled?: boolean;
    /** Клиенты с этим статусом */
    customers?: Customer[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: ICustomerStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers.push(Customer.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): CustomerStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): CustomerStatus {
        const json = this.toJSON();
        let result = new CustomerStatus();
        result.init(json);
        return result;
    }
}

/** Статус клиента */
export interface ICustomerStatus {
    /** Название статуса */
    name?: string | undefined;
    /** ID компании, к которой привязан статус */
    companyId?: string;
    /** Включен ли статус */
    isEnabled?: boolean;
    /** Клиенты с этим статусом */
    customers?: Customer[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель создания и редактирования статуса клиента */
export class CustomerStatusCreateModel implements ICustomerStatusCreateModel {
    /** ID компании */
    companyId?: string | undefined;
    /** Название статуса */
    name?: string | undefined;
    /** Включен ли статус */
    isEnabled?: boolean | undefined;

    constructor(data?: ICustomerStatusCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): CustomerStatusCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerStatusCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["isEnabled"] = this.isEnabled;
        return data;
    }

    clone(): CustomerStatusCreateModel {
        const json = this.toJSON();
        let result = new CustomerStatusCreateModel();
        result.init(json);
        return result;
    }
}

/** Модель создания и редактирования статуса клиента */
export interface ICustomerStatusCreateModel {
    /** ID компании */
    companyId?: string | undefined;
    /** Название статуса */
    name?: string | undefined;
    /** Включен ли статус */
    isEnabled?: boolean | undefined;
}

/** Модель статуса клиента */
export class CustomerStatusModel implements ICustomerStatusModel {
    /** ID статуса клиента */
    id?: string;
    /** Название статуса */
    name?: string | undefined;

    constructor(data?: ICustomerStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CustomerStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): CustomerStatusModel {
        const json = this.toJSON();
        let result = new CustomerStatusModel();
        result.init(json);
        return result;
    }
}

/** Модель статуса клиента */
export interface ICustomerStatusModel {
    /** ID статуса клиента */
    id?: string;
    /** Название статуса */
    name?: string | undefined;
}

/** Модель ошибки */
export class ErrorTemplate implements IErrorTemplate {
    /** Код ошибки */
    statusCode?: number;
    /** Сообщение */
    message?: string | undefined;
    /** Ошибки */
    errors?: any | undefined;

    constructor(data?: IErrorTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.errors = _data["errors"];
        }
    }

    static fromJS(data: any): ErrorTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["errors"] = this.errors;
        return data;
    }

    clone(): ErrorTemplate {
        const json = this.toJSON();
        let result = new ErrorTemplate();
        result.init(json);
        return result;
    }
}

/** Модель ошибки */
export interface IErrorTemplate {
    /** Код ошибки */
    statusCode?: number;
    /** Сообщение */
    message?: string | undefined;
    /** Ошибки */
    errors?: any | undefined;
}

/** Базовая модель для фильтра и сортировки */
export class FilterModel implements IFilterModel {
    /** Текущая страница */
    page?: number;
    /** Количество элементов на странице */
    perPage?: number;
    /** Сортировка */
    sortOrder?: SortOrder;
    /** Поле по которому сортируем */
    sortBy?: string | undefined;

    constructor(data?: IFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.perPage = _data["perPage"];
            this.sortOrder = _data["sortOrder"];
            this.sortBy = _data["sortBy"];
        }
    }

    static fromJS(data: any): FilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["perPage"] = this.perPage;
        data["sortOrder"] = this.sortOrder;
        data["sortBy"] = this.sortBy;
        return data;
    }

    clone(): FilterModel {
        const json = this.toJSON();
        let result = new FilterModel();
        result.init(json);
        return result;
    }
}

/** Базовая модель для фильтра и сортировки */
export interface IFilterModel {
    /** Текущая страница */
    page?: number;
    /** Количество элементов на странице */
    perPage?: number;
    /** Сортировка */
    sortOrder?: SortOrder;
    /** Поле по которому сортируем */
    sortBy?: string | undefined;
}

/** Модель JWT токена авторизации */
export class JwtResponse implements IJwtResponse {
    /** Access token для системы Nimbus */
    accessToken?: string | undefined;
    /** refresh token для системы Nimbus */
    refreshToken?: string | undefined;
    /** Дата истечения токена */
    expiresAt?: Date;

    constructor(data?: IJwtResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JwtResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JwtResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): JwtResponse {
        const json = this.toJSON();
        let result = new JwtResponse();
        result.init(json);
        return result;
    }
}

/** Модель JWT токена авторизации */
export interface IJwtResponse {
    /** Access token для системы Nimbus */
    accessToken?: string | undefined;
    /** refresh token для системы Nimbus */
    refreshToken?: string | undefined;
    /** Дата истечения токена */
    expiresAt?: Date;
}

/** Клиенты создают заказ */
export class Order implements IOrder {
    /** ID компании, к которой привязан заказ */
    companyId?: string;
    /** ID клиента */
    customerId?: string;
    /** Сайт, с которого был создан заказ */
    websiteUrl?: string | undefined;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента (На него будет отправлено уведомление об успешном оформлении заказа) */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Название компании для которой был оформлен заказ */
    company?: string | undefined;
    /** Адрес */
    address?: AddressModel | undefined;
    /** Адрес доставки товара */
    shippingAddress?: AddressModel | undefined;
    /** Сумма заказа */
    total?: number;
    /** Кастомные */
    customFees?: CustomFeeModel[] | undefined;
    /** Клиент */
    customer?: Customer | undefined;
    /** Валюта заказа */
    currency?: string | undefined;
    /** Комментарий к заказу */
    comment?: string | undefined;
    /** ID пользователя, который создал заказ */
    userId?: string | undefined;
    /** Пользователь, который создал заказ */
    user?: User | undefined;
    /** Статус заказа */
    status?: OrderStatus | undefined;
    /** Товары в заказе */
    products?: OrderProduct[] | undefined;
    /** Комментарии к заказу */
    notes?: OrderNote[] | undefined;
    /** Код заказа (Читаемый код, который можно передать клиенту и сотруднику) */
    code?: string | undefined;
    /** Параметры заказа */
    properties?: OrderProperty[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.customerId = _data["customerId"];
            this.websiteUrl = _data["websiteUrl"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.company = _data["company"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.shippingAddress = _data["shippingAddress"] ? AddressModel.fromJS(_data["shippingAddress"]) : <any>undefined;
            this.total = _data["total"];
            if (Array.isArray(_data["customFees"])) {
                this.customFees = [] as any;
                for (let item of _data["customFees"])
                    this.customFees.push(CustomFeeModel.fromJS(item));
            }
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.currency = _data["currency"];
            this.comment = _data["comment"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(OrderProduct.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(OrderNote.fromJS(item));
            }
            this.code = _data["code"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties.push(OrderProperty.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["customerId"] = this.customerId;
        data["websiteUrl"] = this.websiteUrl;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["company"] = this.company;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        data["total"] = this.total;
        if (Array.isArray(this.customFees)) {
            data["customFees"] = [];
            for (let item of this.customFees)
                data["customFees"].push(item.toJSON());
        }
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["currency"] = this.currency;
        data["comment"] = this.comment;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): Order {
        const json = this.toJSON();
        let result = new Order();
        result.init(json);
        return result;
    }
}

/** Клиенты создают заказ */
export interface IOrder {
    /** ID компании, к которой привязан заказ */
    companyId?: string;
    /** ID клиента */
    customerId?: string;
    /** Сайт, с которого был создан заказ */
    websiteUrl?: string | undefined;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента (На него будет отправлено уведомление об успешном оформлении заказа) */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Название компании для которой был оформлен заказ */
    company?: string | undefined;
    /** Адрес */
    address?: AddressModel | undefined;
    /** Адрес доставки товара */
    shippingAddress?: AddressModel | undefined;
    /** Сумма заказа */
    total?: number;
    /** Кастомные */
    customFees?: CustomFeeModel[] | undefined;
    /** Клиент */
    customer?: Customer | undefined;
    /** Валюта заказа */
    currency?: string | undefined;
    /** Комментарий к заказу */
    comment?: string | undefined;
    /** ID пользователя, который создал заказ */
    userId?: string | undefined;
    /** Пользователь, который создал заказ */
    user?: User | undefined;
    /** Статус заказа */
    status?: OrderStatus | undefined;
    /** Товары в заказе */
    products?: OrderProduct[] | undefined;
    /** Комментарии к заказу */
    notes?: OrderNote[] | undefined;
    /** Код заказа (Читаемый код, который можно передать клиенту и сотруднику) */
    code?: string | undefined;
    /** Параметры заказа */
    properties?: OrderProperty[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель отмены заказа */
export class OrderCancelationModel implements IOrderCancelationModel {
    /** Комментарий к отмене заказа */
    comment?: string | undefined;
    /** Модель платежа (Для создания рефаунда) */
    payment?: PaymentCreateModel | undefined;
    /** Массив параметров (Дополнительные действия, функции, вебхуки и т.д) */
    properties?: PropertyModel[] | undefined;

    constructor(data?: IOrderCancelationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.payment = _data["payment"] ? PaymentCreateModel.fromJS(_data["payment"]) : <any>undefined;
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties.push(PropertyModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderCancelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCancelationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderCancelationModel {
        const json = this.toJSON();
        let result = new OrderCancelationModel();
        result.init(json);
        return result;
    }
}

/** Модель отмены заказа */
export interface IOrderCancelationModel {
    /** Комментарий к отмене заказа */
    comment?: string | undefined;
    /** Модель платежа (Для создания рефаунда) */
    payment?: PaymentCreateModel | undefined;
    /** Массив параметров (Дополнительные действия, функции, вебхуки и т.д) */
    properties?: PropertyModel[] | undefined;
}

/** Модель создания заказа */
export class OrderCreateModel implements IOrderCreateModel {
    /** ID компании для которой создается заказ */
    companyId?: string | undefined;
    /** ID клиента */
    customerId?: string | undefined;
    /** Сайт, с которого был создан заказ */
    websiteUrl?: string | undefined;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента (На него будет отправлено уведомление об успешном оформлении заказа) */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Название компании для которой был оформлен заказ */
    company?: string | undefined;
    /** Адрес */
    address?: AddressModel | undefined;
    /** Адрес доставки товара */
    shippingAddress?: AddressModel | undefined;
    /** Кастомные */
    customFees?: CustomFeeModel[] | undefined;
    /** Валюта заказа */
    currency?: string | undefined;
    /** Комментарий к заказу */
    comment?: string | undefined;
    /** ID пользователя, который создал заказ */
    userId?: string | undefined;
    /** Товары в заказе */
    products?: OrderProductCreateModel[] | undefined;
    /** Префикс заказа */
    prefix?: string | undefined;

    constructor(data?: IOrderCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.customerId = _data["customerId"];
            this.websiteUrl = _data["websiteUrl"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.company = _data["company"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.shippingAddress = _data["shippingAddress"] ? AddressModel.fromJS(_data["shippingAddress"]) : <any>undefined;
            if (Array.isArray(_data["customFees"])) {
                this.customFees = [] as any;
                for (let item of _data["customFees"])
                    this.customFees.push(CustomFeeModel.fromJS(item));
            }
            this.currency = _data["currency"];
            this.comment = _data["comment"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(OrderProductCreateModel.fromJS(item));
            }
            this.prefix = _data["prefix"];
        }
    }

    static fromJS(data: any): OrderCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["customerId"] = this.customerId;
        data["websiteUrl"] = this.websiteUrl;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["company"] = this.company;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.customFees)) {
            data["customFees"] = [];
            for (let item of this.customFees)
                data["customFees"].push(item.toJSON());
        }
        data["currency"] = this.currency;
        data["comment"] = this.comment;
        data["userId"] = this.userId;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["prefix"] = this.prefix;
        return data;
    }

    clone(): OrderCreateModel {
        const json = this.toJSON();
        let result = new OrderCreateModel();
        result.init(json);
        return result;
    }
}

/** Модель создания заказа */
export interface IOrderCreateModel {
    /** ID компании для которой создается заказ */
    companyId?: string | undefined;
    /** ID клиента */
    customerId?: string | undefined;
    /** Сайт, с которого был создан заказ */
    websiteUrl?: string | undefined;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента (На него будет отправлено уведомление об успешном оформлении заказа) */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Название компании для которой был оформлен заказ */
    company?: string | undefined;
    /** Адрес */
    address?: AddressModel | undefined;
    /** Адрес доставки товара */
    shippingAddress?: AddressModel | undefined;
    /** Кастомные */
    customFees?: CustomFeeModel[] | undefined;
    /** Валюта заказа */
    currency?: string | undefined;
    /** Комментарий к заказу */
    comment?: string | undefined;
    /** ID пользователя, который создал заказ */
    userId?: string | undefined;
    /** Товары в заказе */
    products?: OrderProductCreateModel[] | undefined;
    /** Префикс заказа */
    prefix?: string | undefined;
}

/** Модель фильтра заказов */
export class OrderFilterModel implements IOrderFilterModel {
    /** Id заказа */
    id?: string | undefined;
    /** Фильтр по дате создания заказа */
    createdFrom?: Date | undefined;
    /** Фильтр по дате создания заказа */
    createdTo?: Date | undefined;
    /** Фильтр по статусу заказа */
    statuses?: OrderStatus[] | undefined;
    /** Фильтр по клиенту */
    customerId?: string | undefined;
    /** Фильтр по сайту, на котором был создан заказ */
    websites?: string[] | undefined;
    /** Фильтр по товарам */
    products?: string[] | undefined;
    /** Фильтр по пользователям, которые создали заказ */
    users?: string[] | undefined;
    /** Фильтр по валюте заказа */
    currencies?: string[] | undefined;
    /** Фильтр по сумме заказа (ОТ) */
    totalFrom?: number | undefined;
    /** Фильтр по сумме заказа (ДО) */
    totalTo?: number | undefined;
    /** Текущая страница */
    page?: number;
    /** Количество элементов на странице */
    perPage?: number;
    /** Сортировка */
    sortOrder?: SortOrder;
    /** Поле по которому сортируем */
    sortBy?: string | undefined;

    constructor(data?: IOrderFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdFrom = _data["createdFrom"] ? new Date(_data["createdFrom"].toString()) : <any>undefined;
            this.createdTo = _data["createdTo"] ? new Date(_data["createdTo"].toString()) : <any>undefined;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses.push(item);
            }
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites.push(item);
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(item);
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users.push(item);
            }
            if (Array.isArray(_data["currencies"])) {
                this.currencies = [] as any;
                for (let item of _data["currencies"])
                    this.currencies.push(item);
            }
            this.totalFrom = _data["totalFrom"];
            this.totalTo = _data["totalTo"];
            this.page = _data["page"];
            this.perPage = _data["perPage"];
            this.sortOrder = _data["sortOrder"];
            this.sortBy = _data["sortBy"];
        }
    }

    static fromJS(data: any): OrderFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdFrom"] = this.createdFrom ? this.createdFrom.toISOString() : <any>undefined;
        data["createdTo"] = this.createdTo ? this.createdTo.toISOString() : <any>undefined;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        data["customerId"] = this.customerId;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item);
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        if (Array.isArray(this.currencies)) {
            data["currencies"] = [];
            for (let item of this.currencies)
                data["currencies"].push(item);
        }
        data["totalFrom"] = this.totalFrom;
        data["totalTo"] = this.totalTo;
        data["page"] = this.page;
        data["perPage"] = this.perPage;
        data["sortOrder"] = this.sortOrder;
        data["sortBy"] = this.sortBy;
        return data;
    }

    clone(): OrderFilterModel {
        const json = this.toJSON();
        let result = new OrderFilterModel();
        result.init(json);
        return result;
    }
}

/** Модель фильтра заказов */
export interface IOrderFilterModel {
    /** Id заказа */
    id?: string | undefined;
    /** Фильтр по дате создания заказа */
    createdFrom?: Date | undefined;
    /** Фильтр по дате создания заказа */
    createdTo?: Date | undefined;
    /** Фильтр по статусу заказа */
    statuses?: OrderStatus[] | undefined;
    /** Фильтр по клиенту */
    customerId?: string | undefined;
    /** Фильтр по сайту, на котором был создан заказ */
    websites?: string[] | undefined;
    /** Фильтр по товарам */
    products?: string[] | undefined;
    /** Фильтр по пользователям, которые создали заказ */
    users?: string[] | undefined;
    /** Фильтр по валюте заказа */
    currencies?: string[] | undefined;
    /** Фильтр по сумме заказа (ОТ) */
    totalFrom?: number | undefined;
    /** Фильтр по сумме заказа (ДО) */
    totalTo?: number | undefined;
    /** Текущая страница */
    page?: number;
    /** Количество элементов на странице */
    perPage?: number;
    /** Сортировка */
    sortOrder?: SortOrder;
    /** Поле по которому сортируем */
    sortBy?: string | undefined;
}

/** Модель заказа */
export class OrderModel implements IOrderModel {
    /** ID компании, к которой привязан заказ */
    companyId?: string;
    /** ID клиента */
    customerId?: string;
    /** Сайт, с которого был создан заказ */
    websiteUrl?: string | undefined;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента (На него будет отправлено уведомление об успешном оформлении заказа) */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Название компании для которой был оформлен заказ */
    company?: string | undefined;
    /** Адрес */
    address?: AddressModel | undefined;
    /** Адрес доставки товара */
    shippingAddress?: AddressModel | undefined;
    /** Сумма заказа */
    total?: number;
    /** Кастомные */
    customFees?: CustomFeeModel[] | undefined;
    /** Клиент */
    customer?: CustomerModel | undefined;
    /** Статус */
    status?: OrderStatus;
    /** Валюта заказа */
    currency?: string | undefined;
    /** Комментарий к заказу */
    comment?: string | undefined;
    /** ID пользователя, который создал заказ */
    userId?: string | undefined;
    /** Товары в заказе */
    products?: OrderProductModel[] | undefined;
    /** Код заказа */
    code?: string | undefined;
    /** Модель пользователя, который создал заказ */
    user?: UserModel | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.customerId = _data["customerId"];
            this.websiteUrl = _data["websiteUrl"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.company = _data["company"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.shippingAddress = _data["shippingAddress"] ? AddressModel.fromJS(_data["shippingAddress"]) : <any>undefined;
            this.total = _data["total"];
            if (Array.isArray(_data["customFees"])) {
                this.customFees = [] as any;
                for (let item of _data["customFees"])
                    this.customFees.push(CustomFeeModel.fromJS(item));
            }
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.status = _data["status"];
            this.currency = _data["currency"];
            this.comment = _data["comment"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(OrderProductModel.fromJS(item));
            }
            this.code = _data["code"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): OrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["customerId"] = this.customerId;
        data["websiteUrl"] = this.websiteUrl;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["company"] = this.company;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        data["total"] = this.total;
        if (Array.isArray(this.customFees)) {
            data["customFees"] = [];
            for (let item of this.customFees)
                data["customFees"].push(item.toJSON());
        }
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["currency"] = this.currency;
        data["comment"] = this.comment;
        data["userId"] = this.userId;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): OrderModel {
        const json = this.toJSON();
        let result = new OrderModel();
        result.init(json);
        return result;
    }
}

/** Модель заказа */
export interface IOrderModel {
    /** ID компании, к которой привязан заказ */
    companyId?: string;
    /** ID клиента */
    customerId?: string;
    /** Сайт, с которого был создан заказ */
    websiteUrl?: string | undefined;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента (На него будет отправлено уведомление об успешном оформлении заказа) */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Название компании для которой был оформлен заказ */
    company?: string | undefined;
    /** Адрес */
    address?: AddressModel | undefined;
    /** Адрес доставки товара */
    shippingAddress?: AddressModel | undefined;
    /** Сумма заказа */
    total?: number;
    /** Кастомные */
    customFees?: CustomFeeModel[] | undefined;
    /** Клиент */
    customer?: CustomerModel | undefined;
    /** Статус */
    status?: OrderStatus;
    /** Валюта заказа */
    currency?: string | undefined;
    /** Комментарий к заказу */
    comment?: string | undefined;
    /** ID пользователя, который создал заказ */
    userId?: string | undefined;
    /** Товары в заказе */
    products?: OrderProductModel[] | undefined;
    /** Код заказа */
    code?: string | undefined;
    /** Модель пользователя, который создал заказ */
    user?: UserModel | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель пагинации которая возвращается на фронтенд */
export class OrderModelPaginationModel implements IOrderModelPaginationModel {
    /** Список элементов */
    items?: OrderModel[] | undefined;
    /** Количество элементов на странице */
    perPage?: number;
    /** Номер страницы */
    page?: number;
    /** Общее количество элементов с учётом всех фильтров которые были применены */
    total?: number;
    /** Последняя страница */
    lastPage?: number;

    constructor(data?: IOrderModelPaginationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderModel.fromJS(item));
            }
            this.perPage = _data["perPage"];
            this.page = _data["page"];
            this.total = _data["total"];
            this.lastPage = _data["lastPage"];
        }
    }

    static fromJS(data: any): OrderModelPaginationModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModelPaginationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["perPage"] = this.perPage;
        data["page"] = this.page;
        data["total"] = this.total;
        data["lastPage"] = this.lastPage;
        return data;
    }

    clone(): OrderModelPaginationModel {
        const json = this.toJSON();
        let result = new OrderModelPaginationModel();
        result.init(json);
        return result;
    }
}

/** Модель пагинации которая возвращается на фронтенд */
export interface IOrderModelPaginationModel {
    /** Список элементов */
    items?: OrderModel[] | undefined;
    /** Количество элементов на странице */
    perPage?: number;
    /** Номер страницы */
    page?: number;
    /** Общее количество элементов с учётом всех фильтров которые были применены */
    total?: number;
    /** Последняя страница */
    lastPage?: number;
}

/** Заметка о заказе */
export class OrderNote implements IOrderNote {
    /** ID пользователя, создавшего заметку */
    userId?: string | undefined;
    /** Пользователь, создавший заметку */
    user?: User | undefined;
    /** Текст заметки */
    text?: string | undefined;
    /** ID заказа, к которому привязана заметка */
    orderId?: string;
    /** Заказ, к которому привязана заметка */
    order?: Order | undefined;
    /** Новый статус заказа */
    status?: OrderStatus | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IOrderNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.text = _data["text"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.status = _data["status"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): OrderNote {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["text"] = this.text;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): OrderNote {
        const json = this.toJSON();
        let result = new OrderNote();
        result.init(json);
        return result;
    }
}

/** Заметка о заказе */
export interface IOrderNote {
    /** ID пользователя, создавшего заметку */
    userId?: string | undefined;
    /** Пользователь, создавший заметку */
    user?: User | undefined;
    /** Текст заметки */
    text?: string | undefined;
    /** ID заказа, к которому привязана заметка */
    orderId?: string;
    /** Заказ, к которому привязана заметка */
    order?: Order | undefined;
    /** Новый статус заказа */
    status?: OrderStatus | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Товар в заказе */
export class OrderProduct implements IOrderProduct {
    /** ID заказа */
    orderId?: string;
    /** Заказ */
    order?: Order | undefined;
    /** ID товара */
    productId?: string;
    /** Товар */
    product?: Product | undefined;
    /** Цена товара на момент покупки */
    price?: number;
    /** Название товара на момент покупки */
    name?: string | undefined;
    /** Подписка */
    subscription?: Subscription | undefined;
    /** Скидка на товар */
    discount?: number | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IOrderProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.price = _data["price"];
            this.name = _data["name"];
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
            this.discount = _data["discount"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): OrderProduct {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["price"] = this.price;
        data["name"] = this.name;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        data["discount"] = this.discount;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): OrderProduct {
        const json = this.toJSON();
        let result = new OrderProduct();
        result.init(json);
        return result;
    }
}

/** Товар в заказе */
export interface IOrderProduct {
    /** ID заказа */
    orderId?: string;
    /** Заказ */
    order?: Order | undefined;
    /** ID товара */
    productId?: string;
    /** Товар */
    product?: Product | undefined;
    /** Цена товара на момент покупки */
    price?: number;
    /** Название товара на момент покупки */
    name?: string | undefined;
    /** Подписка */
    subscription?: Subscription | undefined;
    /** Скидка на товар */
    discount?: number | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель создания товара в заказе */
export class OrderProductCreateModel implements IOrderProductCreateModel {
    /** Id товара */
    productId?: string | undefined;
    /** Название товара. Если не указано, то берется из базы */
    name?: string | undefined;
    /** Количество товара */
    quantity?: number;
    /** Цена товара */
    price?: number | undefined;
    /** Скидка на товар */
    discount?: number | undefined;

    constructor(data?: IOrderProductCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.discount = _data["discount"];
        }
    }

    static fromJS(data: any): OrderProductCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["discount"] = this.discount;
        return data;
    }

    clone(): OrderProductCreateModel {
        const json = this.toJSON();
        let result = new OrderProductCreateModel();
        result.init(json);
        return result;
    }
}

/** Модель создания товара в заказе */
export interface IOrderProductCreateModel {
    /** Id товара */
    productId?: string | undefined;
    /** Название товара. Если не указано, то берется из базы */
    name?: string | undefined;
    /** Количество товара */
    quantity?: number;
    /** Цена товара */
    price?: number | undefined;
    /** Скидка на товар */
    discount?: number | undefined;
}

/** Модель заметки о заказе */
export class OrderProductModel implements IOrderProductModel {
    /** ID товара */
    productId?: string;
    /** Товар */
    product?: ProductModel | undefined;
    /** Цена товара на момент покупки */
    price?: number;
    /** Название товара на момент покупки */
    name?: string | undefined;
    /** Подписка */
    subscription?: SubscriptionModel | undefined;
    /** Скидка на товар */
    discount?: number | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IOrderProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.product = _data["product"] ? ProductModel.fromJS(_data["product"]) : <any>undefined;
            this.price = _data["price"];
            this.name = _data["name"];
            this.subscription = _data["subscription"] ? SubscriptionModel.fromJS(_data["subscription"]) : <any>undefined;
            this.discount = _data["discount"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): OrderProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["price"] = this.price;
        data["name"] = this.name;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        data["discount"] = this.discount;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): OrderProductModel {
        const json = this.toJSON();
        let result = new OrderProductModel();
        result.init(json);
        return result;
    }
}

/** Модель заметки о заказе */
export interface IOrderProductModel {
    /** ID товара */
    productId?: string;
    /** Товар */
    product?: ProductModel | undefined;
    /** Цена товара на момент покупки */
    price?: number;
    /** Название товара на момент покупки */
    name?: string | undefined;
    /** Подписка */
    subscription?: SubscriptionModel | undefined;
    /** Скидка на товар */
    discount?: number | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

export class OrderProperty implements IOrderProperty {
    orderId?: string;
    name?: string | undefined;
    value?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IOrderProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): OrderProperty {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): OrderProperty {
        const json = this.toJSON();
        let result = new OrderProperty();
        result.init(json);
        return result;
    }
}

export interface IOrderProperty {
    orderId?: string;
    name?: string | undefined;
    value?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Статусы заказов */
export enum OrderStatus {
    Draft = "Draft",
    New = "New",
    Paid = "Paid",
    Processing = "Processing",
    Completed = "Completed",
    Cancelled = "Cancelled",
}

/** Модель обновления заказа */
export class OrderUpdateModel implements IOrderUpdateModel {
    /** Новый статус заказа */
    status?: OrderStatus | undefined;
    /** Комментарий к заказу */
    comment?: string | undefined;
    /** имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Адрес клиента (Платежный) */
    address?: AddressModel | undefined;
    /** Адрес доставки товара */
    shippingAddress?: AddressModel | undefined;

    constructor(data?: IOrderUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.comment = _data["comment"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.shippingAddress = _data["shippingAddress"] ? AddressModel.fromJS(_data["shippingAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["comment"] = this.comment;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        return data;
    }

    clone(): OrderUpdateModel {
        const json = this.toJSON();
        let result = new OrderUpdateModel();
        result.init(json);
        return result;
    }
}

/** Модель обновления заказа */
export interface IOrderUpdateModel {
    /** Новый статус заказа */
    status?: OrderStatus | undefined;
    /** Комментарий к заказу */
    comment?: string | undefined;
    /** имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Имейл клиента */
    email?: string | undefined;
    /** Телефон клиента */
    phone?: string | undefined;
    /** Адрес клиента (Платежный) */
    address?: AddressModel | undefined;
    /** Адрес доставки товара */
    shippingAddress?: AddressModel | undefined;
}

export class OrdersCountResponse implements IOrdersCountResponse {
    currentOrders?: number;
    lastOrders?: number;
    percentageChange?: number | undefined;

    constructor(data?: IOrdersCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentOrders = _data["currentOrders"];
            this.lastOrders = _data["lastOrders"];
            this.percentageChange = _data["percentageChange"];
        }
    }

    static fromJS(data: any): OrdersCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentOrders"] = this.currentOrders;
        data["lastOrders"] = this.lastOrders;
        data["percentageChange"] = this.percentageChange;
        return data;
    }

    clone(): OrdersCountResponse {
        const json = this.toJSON();
        let result = new OrdersCountResponse();
        result.init(json);
        return result;
    }
}

export interface IOrdersCountResponse {
    currentOrders?: number;
    lastOrders?: number;
    percentageChange?: number | undefined;
}

/** Модель платежа */
export class Payment implements IPayment {
    /** Идентификатор заказа (Не номер). Используется, если платеж преналежит заказу, а не товару в заказе */
    orderId?: string | undefined;
    /** Идентификатор товара в заказе, по которому произведена оплата (В случае оплаты за товар не при первой покупке)
К примеру, если клиент оплатил заказ, но затем продлевает подписку - в этом случае будет указан ID товара в заказе, а OrderID будет null */
    orderProductId?: string | undefined;
    /** Связь с товаром в заказе */
    orderProduct?: OrderProduct | undefined;
    /** Сумма платежа всегда в положительном значении.
Если платеж - рефаунд, то платеж всё равно будет в положительном значении, но при этом Type будет Refund или */
    amount?: number;
    /** Идентификатор транзакции на стороне платежной системы */
    transactionId?: string | undefined;
    /** Параметры оплаты (В формате JSON) Смотреть документацию по параметрам платежа */
    properties?: PropertyModel[] | undefined;
    /** Статус платежа */
    status?: PaymentStatus;
    /** Связь с заказом */
    order?: Order | undefined;
    /** Валюта платежа */
    currency?: string | undefined;
    /** Связь с пользователем */
    user?: User | undefined;
    /** Тип платежа */
    type?: PaymentType;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderProductId = _data["orderProductId"];
            this.orderProduct = _data["orderProduct"] ? OrderProduct.fromJS(_data["orderProduct"]) : <any>undefined;
            this.amount = _data["amount"];
            this.transactionId = _data["transactionId"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties.push(PropertyModel.fromJS(item));
            }
            this.status = _data["status"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.currency = _data["currency"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.type = _data["type"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): Payment {
        data = typeof data === 'object' ? data : {};
        let result = new Payment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderProductId"] = this.orderProductId;
        data["orderProduct"] = this.orderProduct ? this.orderProduct.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        data["transactionId"] = this.transactionId;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["currency"] = this.currency;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): Payment {
        const json = this.toJSON();
        let result = new Payment();
        result.init(json);
        return result;
    }
}

/** Модель платежа */
export interface IPayment {
    /** Идентификатор заказа (Не номер). Используется, если платеж преналежит заказу, а не товару в заказе */
    orderId?: string | undefined;
    /** Идентификатор товара в заказе, по которому произведена оплата (В случае оплаты за товар не при первой покупке)
К примеру, если клиент оплатил заказ, но затем продлевает подписку - в этом случае будет указан ID товара в заказе, а OrderID будет null */
    orderProductId?: string | undefined;
    /** Связь с товаром в заказе */
    orderProduct?: OrderProduct | undefined;
    /** Сумма платежа всегда в положительном значении.
Если платеж - рефаунд, то платеж всё равно будет в положительном значении, но при этом Type будет Refund или */
    amount?: number;
    /** Идентификатор транзакции на стороне платежной системы */
    transactionId?: string | undefined;
    /** Параметры оплаты (В формате JSON) Смотреть документацию по параметрам платежа */
    properties?: PropertyModel[] | undefined;
    /** Статус платежа */
    status?: PaymentStatus;
    /** Связь с заказом */
    order?: Order | undefined;
    /** Валюта платежа */
    currency?: string | undefined;
    /** Связь с пользователем */
    user?: User | undefined;
    /** Тип платежа */
    type?: PaymentType;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель добавления платежа в систему */
export class PaymentCreateModel implements IPaymentCreateModel {
    /** Статус платежа */
    status?: PaymentStatus;
    /** Тип платежа */
    type?: PaymentType;
    /** Идентификатор заказа (Не номер). Используется, если платеж преналежит заказу, а не товару в заказе */
    amount?: number;
    /** Валюта платежа */
    currency?: string | undefined;
    /** Идентификатор транзакции на стороне платежной системы */
    transactionId?: string | undefined;
    /** Параметры оплаты (В формате JSON) Смотреть документацию по параметрам платежа */
    properties?: PropertyModel[] | undefined;

    constructor(data?: IPaymentCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.type = _data["type"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.transactionId = _data["transactionId"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties.push(PropertyModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["type"] = this.type;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["transactionId"] = this.transactionId;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaymentCreateModel {
        const json = this.toJSON();
        let result = new PaymentCreateModel();
        result.init(json);
        return result;
    }
}

/** Модель добавления платежа в систему */
export interface IPaymentCreateModel {
    /** Статус платежа */
    status?: PaymentStatus;
    /** Тип платежа */
    type?: PaymentType;
    /** Идентификатор заказа (Не номер). Используется, если платеж преналежит заказу, а не товару в заказе */
    amount?: number;
    /** Валюта платежа */
    currency?: string | undefined;
    /** Идентификатор транзакции на стороне платежной системы */
    transactionId?: string | undefined;
    /** Параметры оплаты (В формате JSON) Смотреть документацию по параметрам платежа */
    properties?: PropertyModel[] | undefined;
}

/** Модель платежа */
export class PaymentModel implements IPaymentModel {
    /** Идентификатор заказа (Не номер). Используется, если платеж преналежит заказу, а не товару в заказе */
    orderId?: string | undefined;
    /** Идентификатор товара в заказе, по которому произведена оплата (В случае оплаты за товар не при первой покупке) */
    orderProductId?: string | undefined;
    /** Связь с заказом */
    order?: OrderModel | undefined;
    /** Связь с товаром в заказе */
    orderProduct?: OrderProductModel | undefined;
    /** Сумма платежа всегда в положительном значении. */
    amount?: number;
    /** Идентификатор транзакции на стороне платежной системы */
    transactionId?: string | undefined;
    /** Параметры оплаты (В формате JSON) Смотреть документацию по параметрам платежа */
    properties?: PropertyModel[] | undefined;
    /** Статус платежа */
    status?: PaymentStatus;
    /** Валюта платежа */
    currency?: string | undefined;
    /** Тип платежа */
    type?: PaymentType;
    /** Модель пользователя */
    user?: UserModel | undefined;
    /** Название продукта, который был оплачен */
    productName?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderProductId = _data["orderProductId"];
            this.order = _data["order"] ? OrderModel.fromJS(_data["order"]) : <any>undefined;
            this.orderProduct = _data["orderProduct"] ? OrderProductModel.fromJS(_data["orderProduct"]) : <any>undefined;
            this.amount = _data["amount"];
            this.transactionId = _data["transactionId"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties.push(PropertyModel.fromJS(item));
            }
            this.status = _data["status"];
            this.currency = _data["currency"];
            this.type = _data["type"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.productName = _data["productName"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): PaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderProductId"] = this.orderProductId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["orderProduct"] = this.orderProduct ? this.orderProduct.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        data["transactionId"] = this.transactionId;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["currency"] = this.currency;
        data["type"] = this.type;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["productName"] = this.productName;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): PaymentModel {
        const json = this.toJSON();
        let result = new PaymentModel();
        result.init(json);
        return result;
    }
}

/** Модель платежа */
export interface IPaymentModel {
    /** Идентификатор заказа (Не номер). Используется, если платеж преналежит заказу, а не товару в заказе */
    orderId?: string | undefined;
    /** Идентификатор товара в заказе, по которому произведена оплата (В случае оплаты за товар не при первой покупке) */
    orderProductId?: string | undefined;
    /** Связь с заказом */
    order?: OrderModel | undefined;
    /** Связь с товаром в заказе */
    orderProduct?: OrderProductModel | undefined;
    /** Сумма платежа всегда в положительном значении. */
    amount?: number;
    /** Идентификатор транзакции на стороне платежной системы */
    transactionId?: string | undefined;
    /** Параметры оплаты (В формате JSON) Смотреть документацию по параметрам платежа */
    properties?: PropertyModel[] | undefined;
    /** Статус платежа */
    status?: PaymentStatus;
    /** Валюта платежа */
    currency?: string | undefined;
    /** Тип платежа */
    type?: PaymentType;
    /** Модель пользователя */
    user?: UserModel | undefined;
    /** Название продукта, который был оплачен */
    productName?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель пагинации которая возвращается на фронтенд */
export class PaymentModelPaginationModel implements IPaymentModelPaginationModel {
    /** Список элементов */
    items?: PaymentModel[] | undefined;
    /** Количество элементов на странице */
    perPage?: number;
    /** Номер страницы */
    page?: number;
    /** Общее количество элементов с учётом всех фильтров которые были применены */
    total?: number;
    /** Последняя страница */
    lastPage?: number;

    constructor(data?: IPaymentModelPaginationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PaymentModel.fromJS(item));
            }
            this.perPage = _data["perPage"];
            this.page = _data["page"];
            this.total = _data["total"];
            this.lastPage = _data["lastPage"];
        }
    }

    static fromJS(data: any): PaymentModelPaginationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentModelPaginationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["perPage"] = this.perPage;
        data["page"] = this.page;
        data["total"] = this.total;
        data["lastPage"] = this.lastPage;
        return data;
    }

    clone(): PaymentModelPaginationModel {
        const json = this.toJSON();
        let result = new PaymentModelPaginationModel();
        result.init(json);
        return result;
    }
}

/** Модель пагинации которая возвращается на фронтенд */
export interface IPaymentModelPaginationModel {
    /** Список элементов */
    items?: PaymentModel[] | undefined;
    /** Количество элементов на странице */
    perPage?: number;
    /** Номер страницы */
    page?: number;
    /** Общее количество элементов с учётом всех фильтров которые были применены */
    total?: number;
    /** Последняя страница */
    lastPage?: number;
}

/** Статус платежа */
export enum PaymentStatus {
    Pending = "Pending",
    Completed = "Completed",
    Failed = "Failed",
}

/** Типы оплат */
export enum PaymentType {
    NewOrder = "NewOrder",
    AdditionalProduct = "AdditionalProduct",
    RecurringPayment = "RecurringPayment",
    Other = "Other",
    Refund = "Refund",
    PartialRefund = "PartialRefund",
}

/** Товар либо услуга */
export class Product implements IProduct {
    /** ID компании, к которой привязан товар */
    companyId?: string;
    /** Название товара */
    name?: string | undefined;
    /** Цена товара */
    price?: number;
    /** Описание товара */
    description?: string | undefined;
    /** Включён ли товар */
    isEnabled?: boolean;
    /** Требует ли этот товар доставку */
    requireShipping?: boolean;
    /** Товары в заказах */
    orderProducts?: OrderProduct[] | undefined;
    /** Свойства товара */
    properties?: ProductProperty[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
            this.requireShipping = _data["requireShipping"];
            if (Array.isArray(_data["orderProducts"])) {
                this.orderProducts = [] as any;
                for (let item of _data["orderProducts"])
                    this.orderProducts.push(OrderProduct.fromJS(item));
            }
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties.push(ProductProperty.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["price"] = this.price;
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        data["requireShipping"] = this.requireShipping;
        if (Array.isArray(this.orderProducts)) {
            data["orderProducts"] = [];
            for (let item of this.orderProducts)
                data["orderProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): Product {
        const json = this.toJSON();
        let result = new Product();
        result.init(json);
        return result;
    }
}

/** Товар либо услуга */
export interface IProduct {
    /** ID компании, к которой привязан товар */
    companyId?: string;
    /** Название товара */
    name?: string | undefined;
    /** Цена товара */
    price?: number;
    /** Описание товара */
    description?: string | undefined;
    /** Включён ли товар */
    isEnabled?: boolean;
    /** Требует ли этот товар доставку */
    requireShipping?: boolean;
    /** Товары в заказах */
    orderProducts?: OrderProduct[] | undefined;
    /** Свойства товара */
    properties?: ProductProperty[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель создания товара */
export class ProductCreateModel implements IProductCreateModel {
    /** ID компании, к которой привязан товар */
    companyId?: string | undefined;
    /** Название товара */
    name?: string | undefined;
    /** Цена товара */
    price?: number | undefined;
    /** Описание товара */
    description?: string | undefined;
    /** Включён ли товар */
    isEnabled?: boolean | undefined;
    /** Требует ли этот товар доставку */
    requireShipping?: boolean | undefined;

    constructor(data?: IProductCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
            this.requireShipping = _data["requireShipping"];
        }
    }

    static fromJS(data: any): ProductCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["price"] = this.price;
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        data["requireShipping"] = this.requireShipping;
        return data;
    }

    clone(): ProductCreateModel {
        const json = this.toJSON();
        let result = new ProductCreateModel();
        result.init(json);
        return result;
    }
}

/** Модель создания товара */
export interface IProductCreateModel {
    /** ID компании, к которой привязан товар */
    companyId?: string | undefined;
    /** Название товара */
    name?: string | undefined;
    /** Цена товара */
    price?: number | undefined;
    /** Описание товара */
    description?: string | undefined;
    /** Включён ли товар */
    isEnabled?: boolean | undefined;
    /** Требует ли этот товар доставку */
    requireShipping?: boolean | undefined;
}

/** Модель фильтра по товарам */
export class ProductFilterModel implements IProductFilterModel {
    /** Название товара */
    name?: string | undefined;
    /** Цена товара от */
    priceFrom?: number | undefined;
    /** Цена товара до */
    priceTo?: number | undefined;
    /** Описание товара */
    description?: string | undefined;
    /** Включён ли товар */
    isEnabled?: boolean | undefined;
    /** Требует ли этот товар доставку */
    requireShipping?: boolean | undefined;
    /** Текущая страница */
    page?: number;
    /** Количество элементов на странице */
    perPage?: number;
    /** Сортировка */
    sortOrder?: SortOrder;
    /** Поле по которому сортируем */
    sortBy?: string | undefined;

    constructor(data?: IProductFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.priceFrom = _data["priceFrom"];
            this.priceTo = _data["priceTo"];
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
            this.requireShipping = _data["requireShipping"];
            this.page = _data["page"];
            this.perPage = _data["perPage"];
            this.sortOrder = _data["sortOrder"];
            this.sortBy = _data["sortBy"];
        }
    }

    static fromJS(data: any): ProductFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["priceFrom"] = this.priceFrom;
        data["priceTo"] = this.priceTo;
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        data["requireShipping"] = this.requireShipping;
        data["page"] = this.page;
        data["perPage"] = this.perPage;
        data["sortOrder"] = this.sortOrder;
        data["sortBy"] = this.sortBy;
        return data;
    }

    clone(): ProductFilterModel {
        const json = this.toJSON();
        let result = new ProductFilterModel();
        result.init(json);
        return result;
    }
}

/** Модель фильтра по товарам */
export interface IProductFilterModel {
    /** Название товара */
    name?: string | undefined;
    /** Цена товара от */
    priceFrom?: number | undefined;
    /** Цена товара до */
    priceTo?: number | undefined;
    /** Описание товара */
    description?: string | undefined;
    /** Включён ли товар */
    isEnabled?: boolean | undefined;
    /** Требует ли этот товар доставку */
    requireShipping?: boolean | undefined;
    /** Текущая страница */
    page?: number;
    /** Количество элементов на странице */
    perPage?: number;
    /** Сортировка */
    sortOrder?: SortOrder;
    /** Поле по которому сортируем */
    sortBy?: string | undefined;
}

/** Модель товара */
export class ProductModel implements IProductModel {
    /** ID компании, к которой привязан товар */
    companyId?: string;
    /** Название товара */
    name?: string | undefined;
    /** Цена товара */
    price?: number;
    /** Описание товара */
    description?: string | undefined;
    /** Включён ли товар */
    isEnabled?: boolean;
    /** Требует ли этот товар доставку */
    requireShipping?: boolean;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
            this.requireShipping = _data["requireShipping"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): ProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["price"] = this.price;
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        data["requireShipping"] = this.requireShipping;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): ProductModel {
        const json = this.toJSON();
        let result = new ProductModel();
        result.init(json);
        return result;
    }
}

/** Модель товара */
export interface IProductModel {
    /** ID компании, к которой привязан товар */
    companyId?: string;
    /** Название товара */
    name?: string | undefined;
    /** Цена товара */
    price?: number;
    /** Описание товара */
    description?: string | undefined;
    /** Включён ли товар */
    isEnabled?: boolean;
    /** Требует ли этот товар доставку */
    requireShipping?: boolean;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель пагинации которая возвращается на фронтенд */
export class ProductModelPaginationModel implements IProductModelPaginationModel {
    /** Список элементов */
    items?: ProductModel[] | undefined;
    /** Количество элементов на странице */
    perPage?: number;
    /** Номер страницы */
    page?: number;
    /** Общее количество элементов с учётом всех фильтров которые были применены */
    total?: number;
    /** Последняя страница */
    lastPage?: number;

    constructor(data?: IProductModelPaginationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductModel.fromJS(item));
            }
            this.perPage = _data["perPage"];
            this.page = _data["page"];
            this.total = _data["total"];
            this.lastPage = _data["lastPage"];
        }
    }

    static fromJS(data: any): ProductModelPaginationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductModelPaginationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["perPage"] = this.perPage;
        data["page"] = this.page;
        data["total"] = this.total;
        data["lastPage"] = this.lastPage;
        return data;
    }

    clone(): ProductModelPaginationModel {
        const json = this.toJSON();
        let result = new ProductModelPaginationModel();
        result.init(json);
        return result;
    }
}

/** Модель пагинации которая возвращается на фронтенд */
export interface IProductModelPaginationModel {
    /** Список элементов */
    items?: ProductModel[] | undefined;
    /** Количество элементов на странице */
    perPage?: number;
    /** Номер страницы */
    page?: number;
    /** Общее количество элементов с учётом всех фильтров которые были применены */
    total?: number;
    /** Последняя страница */
    lastPage?: number;
}

/** Свойство товара */
export class ProductProperty implements IProductProperty {
    /** ID товара */
    productId?: string;
    /** Товар */
    product?: Product | undefined;
    /** Название свойства */
    name?: string | undefined;
    /** Значение свойства */
    value?: string | undefined;
    /** Код свойства (для удобства поиска) */
    code?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IProductProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.name = _data["name"];
            this.value = _data["value"];
            this.code = _data["code"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): ProductProperty {
        data = typeof data === 'object' ? data : {};
        let result = new ProductProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["value"] = this.value;
        data["code"] = this.code;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): ProductProperty {
        const json = this.toJSON();
        let result = new ProductProperty();
        result.init(json);
        return result;
    }
}

/** Свойство товара */
export interface IProductProperty {
    /** ID товара */
    productId?: string;
    /** Товар */
    product?: Product | undefined;
    /** Название свойства */
    name?: string | undefined;
    /** Значение свойства */
    value?: string | undefined;
    /** Код свойства (для удобства поиска) */
    code?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель создания или обновления параметра продукта */
export class ProductPropertyCreateModel implements IProductPropertyCreateModel {
    /** Код свойства */
    code?: string | undefined;
    /** Название свойства */
    name?: string | undefined;
    /** Значение свойства */
    value?: string | undefined;

    constructor(data?: IProductPropertyCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProductPropertyCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPropertyCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): ProductPropertyCreateModel {
        const json = this.toJSON();
        let result = new ProductPropertyCreateModel();
        result.init(json);
        return result;
    }
}

/** Модель создания или обновления параметра продукта */
export interface IProductPropertyCreateModel {
    /** Код свойства */
    code?: string | undefined;
    /** Название свойства */
    name?: string | undefined;
    /** Значение свойства */
    value?: string | undefined;
}

/** Модель свойства товара */
export class ProductPropertyModel implements IProductPropertyModel {
    /** Код свойства */
    code?: string | undefined;
    /** Название свойства */
    name?: string | undefined;
    /** Значение свойства */
    value?: string | undefined;

    constructor(data?: IProductPropertyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProductPropertyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPropertyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): ProductPropertyModel {
        const json = this.toJSON();
        let result = new ProductPropertyModel();
        result.init(json);
        return result;
    }
}

/** Модель свойства товара */
export interface IProductPropertyModel {
    /** Код свойства */
    code?: string | undefined;
    /** Название свойства */
    name?: string | undefined;
    /** Значение свойства */
    value?: string | undefined;
}

/** Модель фильтра для параметров */
export class PropertyFilterModel implements IPropertyFilterModel {
    /** ID параметра */
    id?: string | undefined;
    /** Значение параметра */
    value?: string | undefined;

    constructor(data?: IPropertyFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PropertyFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }

    clone(): PropertyFilterModel {
        const json = this.toJSON();
        let result = new PropertyFilterModel();
        result.init(json);
        return result;
    }
}

/** Модель фильтра для параметров */
export interface IPropertyFilterModel {
    /** ID параметра */
    id?: string | undefined;
    /** Значение параметра */
    value?: string | undefined;
}

/** Модель параметров. Создано для интеграции с другими сервисами либо внутренней логике */
export class PropertyModel implements IPropertyModel {
    /** ID параметра */
    id?: string | undefined;
    /** Значение параметра */
    value?: string | undefined;
    /** Тип данных параметра */
    valueType?: ValueType;
    /** Тип данных массива (Только в случае ValueType.Array) */
    arrayType?: ValueType | undefined;

    constructor(data?: IPropertyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
            this.arrayType = _data["arrayType"];
        }
    }

    static fromJS(data: any): PropertyModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        data["arrayType"] = this.arrayType;
        return data;
    }

    clone(): PropertyModel {
        const json = this.toJSON();
        let result = new PropertyModel();
        result.init(json);
        return result;
    }
}

/** Модель параметров. Создано для интеграции с другими сервисами либо внутренней логике */
export interface IPropertyModel {
    /** ID параметра */
    id?: string | undefined;
    /** Значение параметра */
    value?: string | undefined;
    /** Тип данных параметра */
    valueType?: ValueType;
    /** Тип данных массива (Только в случае ValueType.Array) */
    arrayType?: ValueType | undefined;
}

/** Модель обновления параметра */
export class PropertyUpdateModel implements IPropertyUpdateModel {
    /** Значение свойства */
    value?: string | undefined;

    constructor(data?: IPropertyUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PropertyUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }

    clone(): PropertyUpdateModel {
        const json = this.toJSON();
        let result = new PropertyUpdateModel();
        result.init(json);
        return result;
    }
}

/** Модель обновления параметра */
export interface IPropertyUpdateModel {
    /** Значение свойства */
    value?: string | undefined;
}

/** Модель поиска чего-либо в системе по пагинации. К примеру - поиск по ключевому слову в системе для нахождения клиента */
export class QueryModel implements IQueryModel {
    /** Строка поиска для запроса */
    query?: string | undefined;
    /** Текущая страница */
    page?: number;
    /** Количество элементов на странице */
    perPage?: number;
    /** Сортировка */
    sortOrder?: SortOrder;
    /** Поле по которому сортируем */
    sortBy?: string | undefined;

    constructor(data?: IQueryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.page = _data["page"];
            this.perPage = _data["perPage"];
            this.sortOrder = _data["sortOrder"];
            this.sortBy = _data["sortBy"];
        }
    }

    static fromJS(data: any): QueryModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["page"] = this.page;
        data["perPage"] = this.perPage;
        data["sortOrder"] = this.sortOrder;
        data["sortBy"] = this.sortBy;
        return data;
    }

    clone(): QueryModel {
        const json = this.toJSON();
        let result = new QueryModel();
        result.init(json);
        return result;
    }
}

/** Модель поиска чего-либо в системе по пагинации. К примеру - поиск по ключевому слову в системе для нахождения клиента */
export interface IQueryModel {
    /** Строка поиска для запроса */
    query?: string | undefined;
    /** Текущая страница */
    page?: number;
    /** Количество элементов на странице */
    perPage?: number;
    /** Сортировка */
    sortOrder?: SortOrder;
    /** Поле по которому сортируем */
    sortBy?: string | undefined;
}

/** Модель запроса на обновление токена */
export class RefreshTokenRequest implements IRefreshTokenRequest {
    /** Refresh token для обновления токена */
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }

    clone(): RefreshTokenRequest {
        const json = this.toJSON();
        let result = new RefreshTokenRequest();
        result.init(json);
        return result;
    }
}

/** Модель запроса на обновление токена */
export interface IRefreshTokenRequest {
    /** Refresh token для обновления токена */
    refreshToken?: string | undefined;
}

export class RevenueResponse implements IRevenueResponse {
    currentRevenue?: number;
    lastRevenue?: number;
    percentageChange?: number | undefined;

    constructor(data?: IRevenueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentRevenue = _data["currentRevenue"];
            this.lastRevenue = _data["lastRevenue"];
            this.percentageChange = _data["percentageChange"];
        }
    }

    static fromJS(data: any): RevenueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentRevenue"] = this.currentRevenue;
        data["lastRevenue"] = this.lastRevenue;
        data["percentageChange"] = this.percentageChange;
        return data;
    }

    clone(): RevenueResponse {
        const json = this.toJSON();
        let result = new RevenueResponse();
        result.init(json);
        return result;
    }
}

export interface IRevenueResponse {
    currentRevenue?: number;
    lastRevenue?: number;
    percentageChange?: number | undefined;
}

export class SalesStatisticsDto implements ISalesStatisticsDto {
    /** Список доходов за определенный период времени. */
    income?: number[] | undefined;
    /** Список расходов (возвратов) за определенный период времени. */
    expenses?: number[] | undefined;

    constructor(data?: ISalesStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["income"])) {
                this.income = [] as any;
                for (let item of _data["income"])
                    this.income.push(item);
            }
            if (Array.isArray(_data["expenses"])) {
                this.expenses = [] as any;
                for (let item of _data["expenses"])
                    this.expenses.push(item);
            }
        }
    }

    static fromJS(data: any): SalesStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.income)) {
            data["income"] = [];
            for (let item of this.income)
                data["income"].push(item);
        }
        if (Array.isArray(this.expenses)) {
            data["expenses"] = [];
            for (let item of this.expenses)
                data["expenses"].push(item);
        }
        return data;
    }

    clone(): SalesStatisticsDto {
        const json = this.toJSON();
        let result = new SalesStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface ISalesStatisticsDto {
    /** Список доходов за определенный период времени. */
    income?: number[] | undefined;
    /** Список расходов (возвратов) за определенный период времени. */
    expenses?: number[] | undefined;
}

/** Перечисление для сортировки */
export enum SortOrder {
    Asc = "Asc",
    Desc = "Desc",
}

/** Модель для импорта контактов из системы Strawberry */
export class StarberryImportContactsModel implements IStarberryImportContactsModel {
    /** Контакты для импорта */
    contacts?: StrawberryContactModel[] | undefined;

    constructor(data?: IStarberryImportContactsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts.push(StrawberryContactModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StarberryImportContactsModel {
        data = typeof data === 'object' ? data : {};
        let result = new StarberryImportContactsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        return data;
    }

    clone(): StarberryImportContactsModel {
        const json = this.toJSON();
        let result = new StarberryImportContactsModel();
        result.init(json);
        return result;
    }
}

/** Модель для импорта контактов из системы Strawberry */
export interface IStarberryImportContactsModel {
    /** Контакты для импорта */
    contacts?: StrawberryContactModel[] | undefined;
}

export class State implements IState {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    countryId?: number;

    constructor(data?: IState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): State {
        data = typeof data === 'object' ? data : {};
        let result = new State();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["countryId"] = this.countryId;
        return data;
    }

    clone(): State {
        const json = this.toJSON();
        let result = new State();
        result.init(json);
        return result;
    }
}

export interface IState {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    countryId?: number;
}

/** Модель аккаунта в системе Strawberry */
export class StrawberryAccountModel implements IStrawberryAccountModel {
    id?: number;
    provider?: string | undefined;
    providerId?: number;
    login?: number;
    password?: string | undefined;
    parentCode?: string | undefined;
    shortCode?: string | undefined;
    duration?: number;
    dateActivated?: Date | undefined;
    dateExpired?: Date | undefined;
    lastSeen?: Date | undefined;
    enabled?: boolean;
    userId?: number;
    isTrial?: boolean;
    contactId?: number;
    productId?: number;
    serverId?: number;
    maxDevices?: number;
    parentMode?: boolean;
    ipLimit?: boolean;
    isDev?: boolean;
    delay?: number;
    comment?: string | undefined;
    created_at?: Date;
    updated_at?: Date;
    orderProductId?: number;
    checking?: boolean;
    checked?: boolean;

    constructor(data?: IStrawberryAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.provider = _data["provider"];
            this.providerId = _data["providerId"];
            this.login = _data["login"];
            this.password = _data["password"];
            this.parentCode = _data["parentCode"];
            this.shortCode = _data["shortCode"];
            this.duration = _data["duration"];
            this.dateActivated = _data["dateActivated"] ? new Date(_data["dateActivated"].toString()) : <any>undefined;
            this.dateExpired = _data["dateExpired"] ? new Date(_data["dateExpired"].toString()) : <any>undefined;
            this.lastSeen = _data["lastSeen"] ? new Date(_data["lastSeen"].toString()) : <any>undefined;
            this.enabled = _data["enabled"];
            this.userId = _data["userId"];
            this.isTrial = _data["isTrial"];
            this.contactId = _data["contactId"];
            this.productId = _data["productId"];
            this.serverId = _data["serverId"];
            this.maxDevices = _data["maxDevices"];
            this.parentMode = _data["parentMode"];
            this.ipLimit = _data["ipLimit"];
            this.isDev = _data["isDev"];
            this.delay = _data["delay"];
            this.comment = _data["comment"];
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.updated_at = _data["updated_at"] ? new Date(_data["updated_at"].toString()) : <any>undefined;
            this.orderProductId = _data["orderProductId"];
            this.checking = _data["checking"];
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): StrawberryAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new StrawberryAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["provider"] = this.provider;
        data["providerId"] = this.providerId;
        data["login"] = this.login;
        data["password"] = this.password;
        data["parentCode"] = this.parentCode;
        data["shortCode"] = this.shortCode;
        data["duration"] = this.duration;
        data["dateActivated"] = this.dateActivated ? this.dateActivated.toISOString() : <any>undefined;
        data["dateExpired"] = this.dateExpired ? this.dateExpired.toISOString() : <any>undefined;
        data["lastSeen"] = this.lastSeen ? this.lastSeen.toISOString() : <any>undefined;
        data["enabled"] = this.enabled;
        data["userId"] = this.userId;
        data["isTrial"] = this.isTrial;
        data["contactId"] = this.contactId;
        data["productId"] = this.productId;
        data["serverId"] = this.serverId;
        data["maxDevices"] = this.maxDevices;
        data["parentMode"] = this.parentMode;
        data["ipLimit"] = this.ipLimit;
        data["isDev"] = this.isDev;
        data["delay"] = this.delay;
        data["comment"] = this.comment;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        data["orderProductId"] = this.orderProductId;
        data["checking"] = this.checking;
        data["checked"] = this.checked;
        return data;
    }

    clone(): StrawberryAccountModel {
        const json = this.toJSON();
        let result = new StrawberryAccountModel();
        result.init(json);
        return result;
    }
}

/** Модель аккаунта в системе Strawberry */
export interface IStrawberryAccountModel {
    id?: number;
    provider?: string | undefined;
    providerId?: number;
    login?: number;
    password?: string | undefined;
    parentCode?: string | undefined;
    shortCode?: string | undefined;
    duration?: number;
    dateActivated?: Date | undefined;
    dateExpired?: Date | undefined;
    lastSeen?: Date | undefined;
    enabled?: boolean;
    userId?: number;
    isTrial?: boolean;
    contactId?: number;
    productId?: number;
    serverId?: number;
    maxDevices?: number;
    parentMode?: boolean;
    ipLimit?: boolean;
    isDev?: boolean;
    delay?: number;
    comment?: string | undefined;
    created_at?: Date;
    updated_at?: Date;
    orderProductId?: number;
    checking?: boolean;
    checked?: boolean;
}

/** Модель адреса в системе Strawberry */
export class StrawberryAddressModel implements IStrawberryAddressModel {
    /** Address (Full address in US format) */
    address?: string | undefined;
    /** Comment to the address */
    comment?: string | undefined;

    constructor(data?: IStrawberryAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): StrawberryAddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new StrawberryAddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["comment"] = this.comment;
        return data;
    }

    clone(): StrawberryAddressModel {
        const json = this.toJSON();
        let result = new StrawberryAddressModel();
        result.init(json);
        return result;
    }
}

/** Модель адреса в системе Strawberry */
export interface IStrawberryAddressModel {
    /** Address (Full address in US format) */
    address?: string | undefined;
    /** Comment to the address */
    comment?: string | undefined;
}

/** Модель контакта в системе Strawberry */
export class StrawberryContactModel implements IStrawberryContactModel {
    /** Уникальный идентификатор клиента в системе Strawberry */
    id?: number;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Телефоны клиента */
    phones?: StrawberryPhoneModel[] | undefined;
    emails?: StrawberryEmailModel[] | undefined;
    /** Contact's physical addresses */
    addresses?: StrawberryAddressModel[] | undefined;
    /** Status of the contact */
    contactStatusId?: number;
    /** Type of the contact */
    contactTypeId?: number;
    /** ID of the user who created the contact */
    userId?: number;
    /** Date and time of the last contact with the client */
    lastContact?: Date;
    /** date and time when contact was created */
    created_at?: Date;
    /** date and time when contact was updated */
    updated_at?: Date;
    /** date and time when contact's account was expired */
    dateExpired?: Date | undefined;
    /** Date and time when contact last time logged in */
    lastSeen?: Date | undefined;
    /** id of the source */
    sourceId?: number;
    /** Is report active */
    reportActive?: number;
    /** Contact's orders */
    orders?: StrawberryOrderModel[] | undefined;

    constructor(data?: IStrawberryContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones.push(StrawberryPhoneModel.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(StrawberryEmailModel.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses.push(StrawberryAddressModel.fromJS(item));
            }
            this.contactStatusId = _data["contactStatusId"];
            this.contactTypeId = _data["contactTypeId"];
            this.userId = _data["userId"];
            this.lastContact = _data["lastContact"] ? new Date(_data["lastContact"].toString()) : <any>undefined;
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.updated_at = _data["updated_at"] ? new Date(_data["updated_at"].toString()) : <any>undefined;
            this.dateExpired = _data["dateExpired"] ? new Date(_data["dateExpired"].toString()) : <any>undefined;
            this.lastSeen = _data["lastSeen"] ? new Date(_data["lastSeen"].toString()) : <any>undefined;
            this.sourceId = _data["sourceId"];
            this.reportActive = _data["reportActive"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(StrawberryOrderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StrawberryContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new StrawberryContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["contactStatusId"] = this.contactStatusId;
        data["contactTypeId"] = this.contactTypeId;
        data["userId"] = this.userId;
        data["lastContact"] = this.lastContact ? this.lastContact.toISOString() : <any>undefined;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        data["dateExpired"] = this.dateExpired ? this.dateExpired.toISOString() : <any>undefined;
        data["lastSeen"] = this.lastSeen ? this.lastSeen.toISOString() : <any>undefined;
        data["sourceId"] = this.sourceId;
        data["reportActive"] = this.reportActive;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }

    clone(): StrawberryContactModel {
        const json = this.toJSON();
        let result = new StrawberryContactModel();
        result.init(json);
        return result;
    }
}

/** Модель контакта в системе Strawberry */
export interface IStrawberryContactModel {
    /** Уникальный идентификатор клиента в системе Strawberry */
    id?: number;
    /** Имя клиента */
    firstname?: string | undefined;
    /** Фамилия клиента */
    lastname?: string | undefined;
    /** Телефоны клиента */
    phones?: StrawberryPhoneModel[] | undefined;
    emails?: StrawberryEmailModel[] | undefined;
    /** Contact's physical addresses */
    addresses?: StrawberryAddressModel[] | undefined;
    /** Status of the contact */
    contactStatusId?: number;
    /** Type of the contact */
    contactTypeId?: number;
    /** ID of the user who created the contact */
    userId?: number;
    /** Date and time of the last contact with the client */
    lastContact?: Date;
    /** date and time when contact was created */
    created_at?: Date;
    /** date and time when contact was updated */
    updated_at?: Date;
    /** date and time when contact's account was expired */
    dateExpired?: Date | undefined;
    /** Date and time when contact last time logged in */
    lastSeen?: Date | undefined;
    /** id of the source */
    sourceId?: number;
    /** Is report active */
    reportActive?: number;
    /** Contact's orders */
    orders?: StrawberryOrderModel[] | undefined;
}

export class StrawberryEmailModel implements IStrawberryEmailModel {
    email?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IStrawberryEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): StrawberryEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new StrawberryEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["comment"] = this.comment;
        return data;
    }

    clone(): StrawberryEmailModel {
        const json = this.toJSON();
        let result = new StrawberryEmailModel();
        result.init(json);
        return result;
    }
}

export interface IStrawberryEmailModel {
    email?: string | undefined;
    comment?: string | undefined;
}

/** Модель заказа в системе Strawberry */
export class StrawberryOrderModel implements IStrawberryOrderModel {
    id?: number;
    contactId?: number;
    userId?: number;
    status?: string | undefined;
    total?: number;
    created_at?: Date;
    updated_at?: Date;
    currency?: string | undefined;
    products?: StrawberryOrderProductModel[] | undefined;

    constructor(data?: IStrawberryOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.total = _data["total"];
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.updated_at = _data["updated_at"] ? new Date(_data["updated_at"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(StrawberryOrderProductModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StrawberryOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new StrawberryOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["total"] = this.total;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        data["currency"] = this.currency;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }

    clone(): StrawberryOrderModel {
        const json = this.toJSON();
        let result = new StrawberryOrderModel();
        result.init(json);
        return result;
    }
}

/** Модель заказа в системе Strawberry */
export interface IStrawberryOrderModel {
    id?: number;
    contactId?: number;
    userId?: number;
    status?: string | undefined;
    total?: number;
    created_at?: Date;
    updated_at?: Date;
    currency?: string | undefined;
    products?: StrawberryOrderProductModel[] | undefined;
}

export class StrawberryOrderProductModel implements IStrawberryOrderProductModel {
    id?: number;
    orderId?: number;
    productId?: number;
    name?: string | undefined;
    total?: number;
    accountDuration?: number;
    created_at?: Date;
    updated_at?: Date;
    /** Модель аккаунта в системе Strawberry */
    account?: StrawberryAccountModel | undefined;

    constructor(data?: IStrawberryOrderProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.total = _data["total"];
            this.accountDuration = _data["accountDuration"];
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.updated_at = _data["updated_at"] ? new Date(_data["updated_at"].toString()) : <any>undefined;
            this.account = _data["account"] ? StrawberryAccountModel.fromJS(_data["account"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StrawberryOrderProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new StrawberryOrderProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["total"] = this.total;
        data["accountDuration"] = this.accountDuration;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        return data;
    }

    clone(): StrawberryOrderProductModel {
        const json = this.toJSON();
        let result = new StrawberryOrderProductModel();
        result.init(json);
        return result;
    }
}

export interface IStrawberryOrderProductModel {
    id?: number;
    orderId?: number;
    productId?: number;
    name?: string | undefined;
    total?: number;
    accountDuration?: number;
    created_at?: Date;
    updated_at?: Date;
    /** Модель аккаунта в системе Strawberry */
    account?: StrawberryAccountModel | undefined;
}

/** Модель телефона в системе Strawberry */
export class StrawberryPhoneModel implements IStrawberryPhoneModel {
    /** Телефон клиента */
    phone?: string | undefined;
    /** Комментарий к телефону */
    comment?: string | undefined;

    constructor(data?: IStrawberryPhoneModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): StrawberryPhoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new StrawberryPhoneModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["comment"] = this.comment;
        return data;
    }

    clone(): StrawberryPhoneModel {
        const json = this.toJSON();
        let result = new StrawberryPhoneModel();
        result.init(json);
        return result;
    }
}

/** Модель телефона в системе Strawberry */
export interface IStrawberryPhoneModel {
    /** Телефон клиента */
    phone?: string | undefined;
    /** Комментарий к телефону */
    comment?: string | undefined;
}

/** Подписка на услугу клиента */
export class Subscription implements ISubscription {
    /** ID компании, к которой привязана подписка */
    companyId?: string;
    /** Логин подписки */
    login?: string | undefined;
    /** Пароль подписки либо его хеш */
    password?: string | undefined;
    /** Дата активации подписки */
    activatedAt?: Date | undefined;
    /** Дата истечения подписки */
    expiresAt?: Date | undefined;
    /** Дата последнего входа в систему */
    lastSeenAt?: Date | undefined;
    /** Активна ли подписка */
    isActive?: boolean;
    /** Комментарий к подписке */
    comment?: string | undefined;
    /** Параметры подписки */
    properties?: PropertyModel[] | undefined;
    /** ID провайдера подписки */
    providerId?: string;
    /** Провайдер подписки */
    provider?: SubscriptionProvider | undefined;
    /** Товар в заказе */
    orderProduct?: OrderProduct | undefined;
    /** ID товара в заказе */
    orderProductId?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: ISubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.login = _data["login"];
            this.password = _data["password"];
            this.activatedAt = _data["activatedAt"] ? new Date(_data["activatedAt"].toString()) : <any>undefined;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.lastSeenAt = _data["lastSeenAt"] ? new Date(_data["lastSeenAt"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties.push(PropertyModel.fromJS(item));
            }
            this.providerId = _data["providerId"];
            this.provider = _data["provider"] ? SubscriptionProvider.fromJS(_data["provider"]) : <any>undefined;
            this.orderProduct = _data["orderProduct"] ? OrderProduct.fromJS(_data["orderProduct"]) : <any>undefined;
            this.orderProductId = _data["orderProductId"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): Subscription {
        data = typeof data === 'object' ? data : {};
        let result = new Subscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["login"] = this.login;
        data["password"] = this.password;
        data["activatedAt"] = this.activatedAt ? this.activatedAt.toISOString() : <any>undefined;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["lastSeenAt"] = this.lastSeenAt ? this.lastSeenAt.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["comment"] = this.comment;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        data["providerId"] = this.providerId;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["orderProduct"] = this.orderProduct ? this.orderProduct.toJSON() : <any>undefined;
        data["orderProductId"] = this.orderProductId;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): Subscription {
        const json = this.toJSON();
        let result = new Subscription();
        result.init(json);
        return result;
    }
}

/** Подписка на услугу клиента */
export interface ISubscription {
    /** ID компании, к которой привязана подписка */
    companyId?: string;
    /** Логин подписки */
    login?: string | undefined;
    /** Пароль подписки либо его хеш */
    password?: string | undefined;
    /** Дата активации подписки */
    activatedAt?: Date | undefined;
    /** Дата истечения подписки */
    expiresAt?: Date | undefined;
    /** Дата последнего входа в систему */
    lastSeenAt?: Date | undefined;
    /** Активна ли подписка */
    isActive?: boolean;
    /** Комментарий к подписке */
    comment?: string | undefined;
    /** Параметры подписки */
    properties?: PropertyModel[] | undefined;
    /** ID провайдера подписки */
    providerId?: string;
    /** Провайдер подписки */
    provider?: SubscriptionProvider | undefined;
    /** Товар в заказе */
    orderProduct?: OrderProduct | undefined;
    /** ID товара в заказе */
    orderProductId?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель фильтра подписок */
export class SubscriptionFilter implements ISubscriptionFilter {
    /** ID компаний */
    companies?: string[] | undefined;
    /** Логин подписки */
    login?: string | undefined;
    /** Пароль подписки */
    password?: string | undefined;
    /** Дата активации подписки */
    activatedFrom?: Date | undefined;
    /** Дата активации подписки */
    activatedTo?: Date | undefined;
    /** Дата истечения подписки */
    expiresFrom?: Date | undefined;
    /** Дата истечения подписки */
    expiresTo?: Date | undefined;
    /** Дата последнего входа в систему */
    lastSeenFrom?: Date | undefined;
    /** Дата последнего входа в систему */
    lastSeenTo?: Date | undefined;
    /** Активна ли подписка */
    isActive?: boolean | undefined;
    /** ID провайдера подписки */
    providerId?: string | undefined;
    /** Комментарий к подписке */
    comment?: string | undefined;
    /** Фильтр по товару */
    products?: string[] | undefined;
    /** Фильтр по параметрам */
    properties?: PropertyFilterModel[] | undefined;
    /** Клиенты */
    customers?: string[] | undefined;
    /** Текущая страница */
    page?: number;
    /** Количество элементов на странице */
    perPage?: number;
    /** Сортировка */
    sortOrder?: SortOrder;
    /** Поле по которому сортируем */
    sortBy?: string | undefined;

    constructor(data?: ISubscriptionFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies.push(item);
            }
            this.login = _data["login"];
            this.password = _data["password"];
            this.activatedFrom = _data["activatedFrom"] ? new Date(_data["activatedFrom"].toString()) : <any>undefined;
            this.activatedTo = _data["activatedTo"] ? new Date(_data["activatedTo"].toString()) : <any>undefined;
            this.expiresFrom = _data["expiresFrom"] ? new Date(_data["expiresFrom"].toString()) : <any>undefined;
            this.expiresTo = _data["expiresTo"] ? new Date(_data["expiresTo"].toString()) : <any>undefined;
            this.lastSeenFrom = _data["lastSeenFrom"] ? new Date(_data["lastSeenFrom"].toString()) : <any>undefined;
            this.lastSeenTo = _data["lastSeenTo"] ? new Date(_data["lastSeenTo"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.providerId = _data["providerId"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(item);
            }
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties.push(PropertyFilterModel.fromJS(item));
            }
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers.push(item);
            }
            this.page = _data["page"];
            this.perPage = _data["perPage"];
            this.sortOrder = _data["sortOrder"];
            this.sortBy = _data["sortBy"];
        }
    }

    static fromJS(data: any): SubscriptionFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        data["login"] = this.login;
        data["password"] = this.password;
        data["activatedFrom"] = this.activatedFrom ? this.activatedFrom.toISOString() : <any>undefined;
        data["activatedTo"] = this.activatedTo ? this.activatedTo.toISOString() : <any>undefined;
        data["expiresFrom"] = this.expiresFrom ? this.expiresFrom.toISOString() : <any>undefined;
        data["expiresTo"] = this.expiresTo ? this.expiresTo.toISOString() : <any>undefined;
        data["lastSeenFrom"] = this.lastSeenFrom ? this.lastSeenFrom.toISOString() : <any>undefined;
        data["lastSeenTo"] = this.lastSeenTo ? this.lastSeenTo.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["providerId"] = this.providerId;
        data["comment"] = this.comment;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item);
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item);
        }
        data["page"] = this.page;
        data["perPage"] = this.perPage;
        data["sortOrder"] = this.sortOrder;
        data["sortBy"] = this.sortBy;
        return data;
    }

    clone(): SubscriptionFilter {
        const json = this.toJSON();
        let result = new SubscriptionFilter();
        result.init(json);
        return result;
    }
}

/** Модель фильтра подписок */
export interface ISubscriptionFilter {
    /** ID компаний */
    companies?: string[] | undefined;
    /** Логин подписки */
    login?: string | undefined;
    /** Пароль подписки */
    password?: string | undefined;
    /** Дата активации подписки */
    activatedFrom?: Date | undefined;
    /** Дата активации подписки */
    activatedTo?: Date | undefined;
    /** Дата истечения подписки */
    expiresFrom?: Date | undefined;
    /** Дата истечения подписки */
    expiresTo?: Date | undefined;
    /** Дата последнего входа в систему */
    lastSeenFrom?: Date | undefined;
    /** Дата последнего входа в систему */
    lastSeenTo?: Date | undefined;
    /** Активна ли подписка */
    isActive?: boolean | undefined;
    /** ID провайдера подписки */
    providerId?: string | undefined;
    /** Комментарий к подписке */
    comment?: string | undefined;
    /** Фильтр по товару */
    products?: string[] | undefined;
    /** Фильтр по параметрам */
    properties?: PropertyFilterModel[] | undefined;
    /** Клиенты */
    customers?: string[] | undefined;
    /** Текущая страница */
    page?: number;
    /** Количество элементов на странице */
    perPage?: number;
    /** Сортировка */
    sortOrder?: SortOrder;
    /** Поле по которому сортируем */
    sortBy?: string | undefined;
}

/** Модель подписки */
export class SubscriptionModel implements ISubscriptionModel {
    /** ID компании, к которой привязана подписка */
    companyId?: string;
    /** Логин подписки */
    login?: string | undefined;
    /** Пароль подписки либо его хеш */
    password?: string | undefined;
    /** Дата активации подписки */
    activatedAt?: Date | undefined;
    /** Дата истечения подписки */
    expiresAt?: Date | undefined;
    /** Дата последнего входа в систему */
    lastSeenAt?: Date | undefined;
    /** Активна ли подписка */
    isActive?: boolean;
    /** Комментарий к подписке */
    comment?: string | undefined;
    /** Параметры подписки */
    properties?: PropertyModel[] | undefined;
    /** ID провайдера подписки */
    providerId?: string;
    /** Провайдер подписки */
    provider?: SubscriptionProviderModel | undefined;
    /** Товар в заказе */
    orderProduct?: OrderProductModel | undefined;
    /** ID товара в заказе */
    orderProductId?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: ISubscriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.login = _data["login"];
            this.password = _data["password"];
            this.activatedAt = _data["activatedAt"] ? new Date(_data["activatedAt"].toString()) : <any>undefined;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.lastSeenAt = _data["lastSeenAt"] ? new Date(_data["lastSeenAt"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties.push(PropertyModel.fromJS(item));
            }
            this.providerId = _data["providerId"];
            this.provider = _data["provider"] ? SubscriptionProviderModel.fromJS(_data["provider"]) : <any>undefined;
            this.orderProduct = _data["orderProduct"] ? OrderProductModel.fromJS(_data["orderProduct"]) : <any>undefined;
            this.orderProductId = _data["orderProductId"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): SubscriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["login"] = this.login;
        data["password"] = this.password;
        data["activatedAt"] = this.activatedAt ? this.activatedAt.toISOString() : <any>undefined;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["lastSeenAt"] = this.lastSeenAt ? this.lastSeenAt.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["comment"] = this.comment;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        data["providerId"] = this.providerId;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["orderProduct"] = this.orderProduct ? this.orderProduct.toJSON() : <any>undefined;
        data["orderProductId"] = this.orderProductId;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): SubscriptionModel {
        const json = this.toJSON();
        let result = new SubscriptionModel();
        result.init(json);
        return result;
    }
}

/** Модель подписки */
export interface ISubscriptionModel {
    /** ID компании, к которой привязана подписка */
    companyId?: string;
    /** Логин подписки */
    login?: string | undefined;
    /** Пароль подписки либо его хеш */
    password?: string | undefined;
    /** Дата активации подписки */
    activatedAt?: Date | undefined;
    /** Дата истечения подписки */
    expiresAt?: Date | undefined;
    /** Дата последнего входа в систему */
    lastSeenAt?: Date | undefined;
    /** Активна ли подписка */
    isActive?: boolean;
    /** Комментарий к подписке */
    comment?: string | undefined;
    /** Параметры подписки */
    properties?: PropertyModel[] | undefined;
    /** ID провайдера подписки */
    providerId?: string;
    /** Провайдер подписки */
    provider?: SubscriptionProviderModel | undefined;
    /** Товар в заказе */
    orderProduct?: OrderProductModel | undefined;
    /** ID товара в заказе */
    orderProductId?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель пагинации которая возвращается на фронтенд */
export class SubscriptionModelPaginationModel implements ISubscriptionModelPaginationModel {
    /** Список элементов */
    items?: SubscriptionModel[] | undefined;
    /** Количество элементов на странице */
    perPage?: number;
    /** Номер страницы */
    page?: number;
    /** Общее количество элементов с учётом всех фильтров которые были применены */
    total?: number;
    /** Последняя страница */
    lastPage?: number;

    constructor(data?: ISubscriptionModelPaginationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SubscriptionModel.fromJS(item));
            }
            this.perPage = _data["perPage"];
            this.page = _data["page"];
            this.total = _data["total"];
            this.lastPage = _data["lastPage"];
        }
    }

    static fromJS(data: any): SubscriptionModelPaginationModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionModelPaginationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["perPage"] = this.perPage;
        data["page"] = this.page;
        data["total"] = this.total;
        data["lastPage"] = this.lastPage;
        return data;
    }

    clone(): SubscriptionModelPaginationModel {
        const json = this.toJSON();
        let result = new SubscriptionModelPaginationModel();
        result.init(json);
        return result;
    }
}

/** Модель пагинации которая возвращается на фронтенд */
export interface ISubscriptionModelPaginationModel {
    /** Список элементов */
    items?: SubscriptionModel[] | undefined;
    /** Количество элементов на странице */
    perPage?: number;
    /** Номер страницы */
    page?: number;
    /** Общее количество элементов с учётом всех фильтров которые были применены */
    total?: number;
    /** Последняя страница */
    lastPage?: number;
}

/** Модель продления подписки */
export class SubscriptionPaymentCreateModel implements ISubscriptionPaymentCreateModel {
    /** Статус платежа */
    status?: PaymentStatus;
    /** Тип платежа */
    type?: PaymentType;
    /** Новая дата и время окончания подписки */
    expiresAt?: Date | undefined;
    /** Идентификатор заказа (Не номер). Используется, если платеж преналежит заказу, а не товару в заказе */
    amount?: number;
    /** Валюта платежа */
    currency?: string | undefined;
    /** Идентификатор транзакции на стороне платежной системы */
    transactionId?: string | undefined;
    /** Параметры оплаты (В формате JSON) Смотреть документацию по параметрам платежа */
    properties?: PropertyModel[] | undefined;

    constructor(data?: ISubscriptionPaymentCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.type = _data["type"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.transactionId = _data["transactionId"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties.push(PropertyModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionPaymentCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["type"] = this.type;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["transactionId"] = this.transactionId;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data;
    }

    clone(): SubscriptionPaymentCreateModel {
        const json = this.toJSON();
        let result = new SubscriptionPaymentCreateModel();
        result.init(json);
        return result;
    }
}

/** Модель продления подписки */
export interface ISubscriptionPaymentCreateModel {
    /** Статус платежа */
    status?: PaymentStatus;
    /** Тип платежа */
    type?: PaymentType;
    /** Новая дата и время окончания подписки */
    expiresAt?: Date | undefined;
    /** Идентификатор заказа (Не номер). Используется, если платеж преналежит заказу, а не товару в заказе */
    amount?: number;
    /** Валюта платежа */
    currency?: string | undefined;
    /** Идентификатор транзакции на стороне платежной системы */
    transactionId?: string | undefined;
    /** Параметры оплаты (В формате JSON) Смотреть документацию по параметрам платежа */
    properties?: PropertyModel[] | undefined;
}

/** Провайдер подписки */
export class SubscriptionProvider implements ISubscriptionProvider {
    /** ID компании, к которой привязан провайдер */
    companyId?: string;
    /** Название провайдера */
    name?: string | undefined;
    /** Подписки на провайдер */
    subscriptions?: Subscription[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: ISubscriptionProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions.push(Subscription.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): SubscriptionProvider {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): SubscriptionProvider {
        const json = this.toJSON();
        let result = new SubscriptionProvider();
        result.init(json);
        return result;
    }
}

/** Провайдер подписки */
export interface ISubscriptionProvider {
    /** ID компании, к которой привязан провайдер */
    companyId?: string;
    /** Название провайдера */
    name?: string | undefined;
    /** Подписки на провайдер */
    subscriptions?: Subscription[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Провайдер подписки */
export class SubscriptionProviderModel implements ISubscriptionProviderModel {
    /** ID компании, к которой привязан провайдер */
    companyId?: string;
    /** Название провайдера */
    name?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: ISubscriptionProviderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): SubscriptionProviderModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionProviderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): SubscriptionProviderModel {
        const json = this.toJSON();
        let result = new SubscriptionProviderModel();
        result.init(json);
        return result;
    }
}

/** Провайдер подписки */
export interface ISubscriptionProviderModel {
    /** ID компании, к которой привязан провайдер */
    companyId?: string;
    /** Название провайдера */
    name?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель обновления подписки в системе */
export class SubscriptionUpdateModel implements ISubscriptionUpdateModel {
    /** Пароль подписки */
    password?: string | undefined;
    /** Дата окончания подписки */
    expiresAt?: Date | undefined;
    /** Дата последнего входа в систему */
    lastSeenAt?: Date | undefined;
    /** Активна ли подписка */
    isActive?: boolean | undefined;
    /** Комментарий к подписке */
    comment?: string | undefined;
    /** ID товара в заказе, к которому нужно перенести подписку */
    orderProductId?: string | undefined;

    constructor(data?: ISubscriptionUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.lastSeenAt = _data["lastSeenAt"] ? new Date(_data["lastSeenAt"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.comment = _data["comment"];
            this.orderProductId = _data["orderProductId"];
        }
    }

    static fromJS(data: any): SubscriptionUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["lastSeenAt"] = this.lastSeenAt ? this.lastSeenAt.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["comment"] = this.comment;
        data["orderProductId"] = this.orderProductId;
        return data;
    }

    clone(): SubscriptionUpdateModel {
        const json = this.toJSON();
        let result = new SubscriptionUpdateModel();
        result.init(json);
        return result;
    }
}

/** Модель обновления подписки в системе */
export interface ISubscriptionUpdateModel {
    /** Пароль подписки */
    password?: string | undefined;
    /** Дата окончания подписки */
    expiresAt?: Date | undefined;
    /** Дата последнего входа в систему */
    lastSeenAt?: Date | undefined;
    /** Активна ли подписка */
    isActive?: boolean | undefined;
    /** Комментарий к подписке */
    comment?: string | undefined;
    /** ID товара в заказе, к которому нужно перенести подписку */
    orderProductId?: string | undefined;
}

/** Модель возврата количества чего-либо после фильтров */
export class TotalModel implements ITotalModel {
    /** Общее число объектов */
    total?: number;
    /** Общее число объектов без учета фильтров */
    totalUnfiltered?: number;

    constructor(data?: ITotalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.totalUnfiltered = _data["totalUnfiltered"];
        }
    }

    static fromJS(data: any): TotalModel {
        data = typeof data === 'object' ? data : {};
        let result = new TotalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["totalUnfiltered"] = this.totalUnfiltered;
        return data;
    }

    clone(): TotalModel {
        const json = this.toJSON();
        let result = new TotalModel();
        result.init(json);
        return result;
    }
}

/** Модель возврата количества чего-либо после фильтров */
export interface ITotalModel {
    /** Общее число объектов */
    total?: number;
    /** Общее число объектов без учета фильтров */
    totalUnfiltered?: number;
}

/** Пользователь */
export class User implements IUser {
    /** User's email uses to log in */
    email?: string | undefined;
    /** Имя пользователя */
    firstname?: string | undefined;
    /** Фамилия пользователя */
    lastname?: string | undefined;
    /** Сессии пользователя (Где он был авторизован) */
    sessions?: UserOAuth[] | undefined;
    /** Статус пользователя */
    status?: UserStatus;
    /** Id роли пользователя */
    roleId?: string;
    /** Роль пользователя */
    role?: UserRole | undefined;
    companyId?: string;
    /** Список заказов пользователя */
    orders?: Order[] | undefined;
    /** Клиенты этого пользователя */
    customers?: Customer[] | undefined;
    /** Cсылка на профиль пользователя */
    profileImage?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions.push(UserOAuth.fromJS(item));
            }
            this.status = _data["status"];
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? UserRole.fromJS(_data["role"]) : <any>undefined;
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers.push(Customer.fromJS(item));
            }
            this.profileImage = _data["profileImage"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["profileImage"] = this.profileImage;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

/** Пользователь */
export interface IUser {
    /** User's email uses to log in */
    email?: string | undefined;
    /** Имя пользователя */
    firstname?: string | undefined;
    /** Фамилия пользователя */
    lastname?: string | undefined;
    /** Сессии пользователя (Где он был авторизован) */
    sessions?: UserOAuth[] | undefined;
    /** Статус пользователя */
    status?: UserStatus;
    /** Id роли пользователя */
    roleId?: string;
    /** Роль пользователя */
    role?: UserRole | undefined;
    companyId?: string;
    /** Список заказов пользователя */
    orders?: Order[] | undefined;
    /** Клиенты этого пользователя */
    customers?: Customer[] | undefined;
    /** Cсылка на профиль пользователя */
    profileImage?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель пользователя */
export class UserModel implements IUserModel {
    /** Имейл пользователя */
    email?: string | undefined;
    /** Имя пользователя */
    firstname?: string | undefined;
    /** Фамилия пользователя */
    lastname?: string | undefined;
    /** Привязанная компания и роль пользователя */
    role?: UserRoleModel | undefined;
    /** ID компании */
    companyId?: string;
    /** Статус пользователя.
pending - Ждём подтверждения по имейлу
active - Подтвердил имейл */
    status?: string | undefined;
    /** Подключён ли пользователь в систему RentSolution */
    isConnected?: boolean;
    /** Ссылка на изображение профиля */
    profileImage?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.role = _data["role"] ? UserRoleModel.fromJS(_data["role"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.status = _data["status"];
            this.isConnected = _data["isConnected"];
            this.profileImage = _data["profileImage"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["status"] = this.status;
        data["isConnected"] = this.isConnected;
        data["profileImage"] = this.profileImage;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): UserModel {
        const json = this.toJSON();
        let result = new UserModel();
        result.init(json);
        return result;
    }
}

/** Модель пользователя */
export interface IUserModel {
    /** Имейл пользователя */
    email?: string | undefined;
    /** Имя пользователя */
    firstname?: string | undefined;
    /** Фамилия пользователя */
    lastname?: string | undefined;
    /** Привязанная компания и роль пользователя */
    role?: UserRoleModel | undefined;
    /** ID компании */
    companyId?: string;
    /** Статус пользователя.
pending - Ждём подтверждения по имейлу
active - Подтвердил имейл */
    status?: string | undefined;
    /** Подключён ли пользователь в систему RentSolution */
    isConnected?: boolean;
    /** Ссылка на изображение профиля */
    profileImage?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** OAuth-токен пользователя */
export class UserOAuth implements IUserOAuth {
    /** ID пользователя, к которому привязан токен */
    userId?: string;
    /** Пользователь, к которому привязан токен */
    user?: User | undefined;
    /** Refresh токен доступа */
    refreshToken?: string | undefined;
    /** Дата и время истечения токена */
    expiresAt?: Date;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IUserOAuth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.refreshToken = _data["refreshToken"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): UserOAuth {
        data = typeof data === 'object' ? data : {};
        let result = new UserOAuth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["refreshToken"] = this.refreshToken;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): UserOAuth {
        const json = this.toJSON();
        let result = new UserOAuth();
        result.init(json);
        return result;
    }
}

/** OAuth-токен пользователя */
export interface IUserOAuth {
    /** ID пользователя, к которому привязан токен */
    userId?: string;
    /** Пользователь, к которому привязан токен */
    user?: User | undefined;
    /** Refresh токен доступа */
    refreshToken?: string | undefined;
    /** Дата и время истечения токена */
    expiresAt?: Date;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Роль пользователя */
export class UserRole implements IUserRole {
    /** Код роли пользователя */
    code?: string | undefined;
    /** Список пользователей с этой ролью */
    users?: User[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users.push(User.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

/** Роль пользователя */
export interface IUserRole {
    /** Код роли пользователя */
    code?: string | undefined;
    /** Список пользователей с этой ролью */
    users?: User[] | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Модель роли пользователя в компании */
export class UserRoleModel implements IUserRoleModel {
    /** Название роли */
    code?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;

    constructor(data?: IUserRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastUpdatedById = _data["lastUpdatedById"];
        }
    }

    static fromJS(data: any): UserRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastUpdatedById"] = this.lastUpdatedById;
        return data;
    }

    clone(): UserRoleModel {
        const json = this.toJSON();
        let result = new UserRoleModel();
        result.init(json);
        return result;
    }
}

/** Модель роли пользователя в компании */
export interface IUserRoleModel {
    /** Название роли */
    code?: string | undefined;
    /** Уникальный идентификатор сущности */
    id?: string;
    /** Дата и время создания сущности (С часовым поясом) */
    createdAt?: Date;
    /** Дата и время последнего обновления сущности (С часовым поясом) */
    updatedAt?: Date;
    /** Idшник пользователя, который создал сущность.
По умолчанию - System */
    createdById?: string | undefined;
    /** Idшник пользователя, который последний раз обновил сущность.
По умолчанию - System */
    lastUpdatedById?: string | undefined;
}

/** Статус пользователя */
export enum UserStatus {
    Created = "Created",
    Confirmed = "Confirmed",
    Disabled = "Disabled",
}

/** Модель UTM-меток для отслеживания источников трафика */
export class UtmModel implements IUtmModel {
    /** UTM-метка source */
    source?: string | undefined;
    /** UTM-метка medium */
    medium?: string | undefined;
    /** UTM-метка campaign */
    campaign?: string | undefined;
    /** UTM-метка term */
    term?: string | undefined;
    /** UTM-метка content */
    content?: string | undefined;

    constructor(data?: IUtmModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.medium = _data["medium"];
            this.campaign = _data["campaign"];
            this.term = _data["term"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): UtmModel {
        data = typeof data === 'object' ? data : {};
        let result = new UtmModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["medium"] = this.medium;
        data["campaign"] = this.campaign;
        data["term"] = this.term;
        data["content"] = this.content;
        return data;
    }

    clone(): UtmModel {
        const json = this.toJSON();
        let result = new UtmModel();
        result.init(json);
        return result;
    }
}

/** Модель UTM-меток для отслеживания источников трафика */
export interface IUtmModel {
    /** UTM-метка source */
    source?: string | undefined;
    /** UTM-метка medium */
    medium?: string | undefined;
    /** UTM-метка campaign */
    campaign?: string | undefined;
    /** UTM-метка term */
    term?: string | undefined;
    /** UTM-метка content */
    content?: string | undefined;
}

/** Типы данных для параметров. Используется для документации а также автоматизации правил валидации */
export enum ValueType {
    String = "String",
    Int = "Int",
    Bool = "Bool",
    Decimal = "Decimal",
    DateTime = "DateTime",
    DateTimeOffset = "DateTimeOffset",
    Guid = "Guid",
    Object = "Object",
    Array = "Array",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}